import logger from '../utils/logger';
import React, { useState, useEffect, useContext, createContext } from 'react';
import '../style/Billing.css';
import { Routes, Route, Link, useParams, useNavigate } from 'react-router-dom';
import UserDetails from './customComponents/tracker';
import { GlobalStateContext, GlobalStateProvider } from '../utils/GlobalStateContext';
import { dateOfBirth, getUserId, formatToLocalDate } from '../utils/utils';
import GearsSpinner from './customComponents/GearsSpinner';

// import React, { useState, useEffect, useContext, createContext } from 'react';
// import '../../style/Biller/Billing.css';
// import { Routes, Route, Link, useParams, useNavigate } from 'react-router-dom';
// import { GlobalStateContext } from "../../GlobalStateContext";
// // import UserDetails from './customComponents/tracker';
// // import { GlobalStateContext, GlobalStateProvider } from '../utils/GlobalStateContext';
// import { dateOfBirth, formatToLocalDate, getUserId } from '../Tools/utils';
// import gearsGif from '../../img/gearsgif.gif';
// import NavBar from '../Tools/NavBar';

// Create the context
export const BillingGlobalStateContext = createContext();
export const BillingGlobalStateProvider = ({ children }) => {

  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
  const [outstandingBalance, setOutstandingBalance] = useState('0.00');
  const [patientResponsibility, setPatientResponsibility] = useState('0.00');
  const [claimId, setClaimId] = useState("");
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const fetchOutstandingBalance = async () => {
    try {
        const response = await fetch(`${BASE_URL}/billing/outstandingBalance?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`);
        if (response.status === 200) {
        const data = await response.json();
        // logger.log("Outstanding balance: ", data.total_due)
        setOutstandingBalance(data.total_due);
        }
    } catch (error) {
        logger.error("Error fetching claims", error);
    }

  };

  const fetchPatientResponsibility = async () => {
    if (currentPatient) {
      try {
        const response = await fetch(`${BASE_URL}/billing/patientResponsibility?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`)
        if (response.status === 200) {
          const data = await response.json();
          // logger.log("Patient responsibility: ", data.total_responsibility)
          setPatientResponsibility(data.total_responsibility);
          }
      } catch (error) {
          logger.error("Error fetching claims", error);
      }
    } else {
      window.alert("No patient selected.");
      }
  }


    useEffect(() => {
      if(currentPatient) {
        fetchOutstandingBalance();
        fetchPatientResponsibility();
      }

    }, []);

    return (
        <BillingGlobalStateContext.Provider value={{ outstandingBalance, setOutstandingBalance, patientResponsibility, setPatientResponsibility, claimId, setClaimId, fetchOutstandingBalance, fetchPatientResponsibility }}>
            {children}
        </BillingGlobalStateContext.Provider>
    );
};

// Hard-coded data
const api = {
    
    searchPatientsApi: async (query, currentUser, user) => {
        const BASE_URL = process.env.REACT_APP_API_URL;
        try {

          const newQry = query
          // logger.log('nq', newQry)
          const response = await fetch(`${BASE_URL}/billing/claims?pNames=${newQry}&user=${user}&type=${currentUser.type}` )  
          if (response.status === 200) {
            const data = await response.json();
            // logger.log(data);
            return data
          } 
          else if (response.status === 404){
            logger.error('Error: Not Found 404');
          }
          else if (response.status === 500){
            logger.error('Error: Internal Server Error 500');
          }
        }
        catch (error) {
          logger.error('Error fetching patients:', error);
        };
      
    }
}
const Worklist = () => {
  const navigate = useNavigate();
  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [billerWorklist, setBillerWorklist] = useState([{
    order_id: '',
    date: '',
    patient_name: '',
    chief_complaint: '',
    clinician_name: '',
    ris_patients_id: ''
  }]);

  const handleWorklistClick = (worklist) => {
    setCurrentPatient(prev => ({
        ...prev,
        patient: [{ ...prev?.patient?.[0], ris_patients_id: worklist.ris_patients_id }]
        }));
    navigate('/generateClaim', {
      state: { order_id: worklist.rad_id }
    });
  }
  
  useEffect(() => {
  const fetchBillerWorklist = async () => {
    try {
      const response = await fetch(`${BASE_URL}/billing/getBillerWorklist?user=${user}&type=${currentUser.type}`);
      if (response.status === 200) {
        const data = await response.json();
        // logger.log(data)
        setBillerWorklist(data);
      }
    } catch (error) {
      logger.error("Error fetching worklist", error);
    }
  };
  
  fetchBillerWorklist();
}, []); // Re-run when `currentPatient` changes

return (
  <div className="ris-billing-generate-claim">
        
        <BillingNavigation />
        <div className="ris-billing-generate-claim-header">
          <h2>Billing Worklist</h2>
        </div>
        
       
        <div className="ris-billing-notes">
          <table>
            <thead>
              <tr>
                <th>Date Created</th>
                {/* <th>Claim Number</th> */}
                <th>Patient Name</th>
                <th>Exam Ordered</th>
                <th>Ordering Clinician</th>
                
              </tr>
            </thead>
            <tbody>
               {billerWorklist?.length > 0 ? billerWorklist.map((work, index) => (
                  <tr key={index}
                  className="biller-worklist-row"
                  onClick={() => {{handleWorklistClick(work);}}}
                  >
                    <td>{dateOfBirth(work.created_at) || 'N/A'}</td>
                    <td>{work.patient_name || 'N/A'}</td>
                    <td>{work.exam_ordered || 'N/A'}</td>
                    <td>{work.ordering_clinician || 'N/A'}</td>
                  </tr>
                )) : null }
            </tbody>
          </table>  
        </div>
      </div>
    
          )

        }

// Navigation component used across all pages
const BillingNavigation = () => {
  const navigate = useNavigate();

  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
  const {currentUser} = useContext(GlobalStateContext);
  // if no patient id, show only the home button to go back
  if (!currentPatient){
    return (
    <div>
      {/* <div>
        <UserDetails></UserDetails>
        
      </div> */}
    <nav className="ris-billing-nav">
      <button onClick={() => navigate('/home')}>Home</button>
      <button onClick={() => navigate('/billing')}>Search Patient</button>
      <button onClick={() => navigate('/billing/claims-summary')}>Claims Summary</button>
      <button onClick={() => navigate('/billing/denials-summary')}>Denials Summary</button>
      <button onClick={() => navigate('/billing/worklist')}>Worklist</button>
      <button onClick={() => navigate('/insurancePlan')}>Insurance Plans</button>
    </nav>
    </div>
    );

  } else {
  //if you have patient id, you can see all of the pages
  return (
    <div>
      {/* <div>
        <UserDetails></UserDetails>
      </div> */}
    <nav className="ris-billing-nav">
      {/* <button onClick={() => navigate('/')}>Back to Home</button> */}
      <button onClick={() => navigate('/home')}>Home</button>
      <button onClick={() => navigate('/generateClaim')}>Generate Claim</button>
      <button onClick={() => navigate('/billing/patient-summary')}>Patient Summary</button>
      <button onClick={() => navigate('/billing/adjustments')}> Claim History/Adjustments</button>
      <button onClick={() => navigate('/billing/generate')}>Claim Info</button>
      <button onClick={() => navigate('/billing/claims-summary')}>Claims Summary</button>
      <button onClick={() => navigate('/billing/denials-summary')}>Denials Summary</button>
      <button onClick={() => navigate('/billing/worklist')}>Worklist</button>
      <button onClick={() => navigate('/insurancePlan')}>Insurance Plans</button>

    </nav>
    </div>
  );
  };
}

// Claims component with note-adding feature 
const Claims = () => {
  const [previousClaims, setPreviousClaims] = useState([]);
  const { outstandingBalance, setOutstandingBalance, fetchOutstandingBalance, fetchPatientResponsibility } = useContext(BillingGlobalStateContext);
  const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);
  const { claimId, setclaimId } = useContext(BillingGlobalStateContext);

  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
  const [newNotes, setNewNotes] = useState([]);
  const [noteForm, setNoteForm] = useState({ note: '', biller: '' });
  const currentDate = new Date().toISOString().split('T')[0];
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
  const fetchClaims = async () => {
    if (currentPatient) {
      try {
        // logger.log(currentPatient)
        const response = await fetch(`${BASE_URL}/billing/getClaims?id=${currentPatient.patient[0].ris_patients_id}&claim_id=${claimId}&user=${user}&type=${currentUser.type}`);
        if (response.status === 200) {
          const data = await response.json();
          setPreviousClaims(data);
        }
      } catch (error) {
        logger.error("Error fetching claims", error);
      }
    } else {
      window.alert("No patient selected.");
    }
  };
  const fetchClaimNote = async () => {
    if (currentPatient) {
      try{
        const response = await fetch(`${BASE_URL}/billing/getClaimNotes?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`);
        const data = await response.json();
        if (response.ok) {
          setNewNotes(data);
        }
      } catch (error) {
        logger.error(error);
      }
    } else {
        window.alert("No patient selected.");
      }
  };

  fetchClaims();
  fetchClaimNote();
  fetchOutstandingBalance();
  fetchPatientResponsibility();
}, []); // Re-run when `currentPatient` changes

 const handleAddNote = async (noteForm) => {
    if (currentPatient) {
      try {
        const response = await fetch(`${BASE_URL}/billing/claimNotes?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(noteForm),
          });
        if (response.ok) {
          const data = await response.json();
          // logger.log(data)
          setNewNotes(data); // test this line
        }
      } catch (err) {
        logger.error("Error message: ", err)
      }
    } else {
      window.alert("No patient selected.");
    }
 }

  const renderInsurance = () => {
    // logger.log("Previous Claims: " + JSON.stringify(previousClaims.insured));
    let payorArray = ["Primary Payor", "Secondary Payor", "Tertiary Payor"];
    return (previousClaims?.insured?.length) ? (
    <div>
      {previousClaims.insured.map((claim, i) => (
        <div className="ris-billing-insurance-section">
          <h3>{payorArray[i]}</h3><br/>
            <div key={i}>
              <p><strong>Insurance Name:</strong> {claim.insurance_name}</p>
              <p><strong>Insurance Full Address:</strong> {claim.insurance_address}</p>
              <p><strong>Insurance Phone Number:</strong> {claim.insurance_phone}</p>
              <p><strong>Insurance Member ID:</strong> {claim.member_id}</p>
              <p><strong>Insurance Group:</strong> {claim.group_number}</p>
              <p><strong>Effective Date:</strong> {dateOfBirth(claim.effective_date)}</p>
              <p><strong>Termination Date:</strong> {dateOfBirth(claim.termination_date)}</p>
              <p><strong>Subscriber Full Name:</strong> {claim.subscriber_name}</p>
              <p><strong>Subscriber DOB:</strong> {dateOfBirth(claim.subscriber_dob)}</p>
              <p><strong>Subscriber Relationship:</strong> {claim.relationship}</p>
            </div>
          </div>
          ))}
      </div>
  ) : null};

  if (previousClaims?.demographics?.length) {
    return (
    
    
      <div className="ris-billing-generate-claim">
        
        <BillingNavigation />
        <div className="ris-billing-generate-claim-header">
          <h2>Claim Information for {previousClaims.demographics[0].patient_name}</h2>
        </div>
        <p><strong>Patient Name:</strong> {previousClaims.demographics[0].patient_name}</p>
        <p><strong>Subscriber Full Address:</strong> {previousClaims.demographics[0].patient_address}, {previousClaims.demographics[0].patient_city}, {previousClaims.demographics[0].patient_state} {previousClaims.demographics[0].patient_zip}</p>
        <p><strong>Subscriber Phone Number:</strong> {previousClaims.demographics[0].patient_phone}</p>
        <p><strong>Outstanding Balance:</strong> ${outstandingBalance}</p>
        <p><strong>Patient Responsibility:</strong> ${patientResponsibility}</p>
        {renderInsurance()}
        <div className="ris-billing-notes">
          <h3>Notes for New Claim</h3>
          <table>
            <thead>
              <tr>
                <th>Biller</th>
                {/* <th>Claim Number</th> */}
                <th>Date</th>
                <th>Note</th>
                
              </tr>
            </thead>
            <tbody>
              { newNotes?.length > 0 ? newNotes.map((note, index) => (
                <tr key={index}>
                  <td>{note.biller}</td>
                  {/* <td>{note.claimNumber}</td> */}
                  <td>{dateOfBirth(note.date)}</td>
                  <td>{note.note}</td>
                  
                </tr>
              )) : null }
            </tbody>
          </table>
          <h4>Add Note for New Claim</h4>

          <div className="ris-billing-add-note">
          <input
              type="text"
              placeholder="Biller"
              value={noteForm.biller}
              onChange={e => setNoteForm({ ...noteForm, biller: e.target.value })}
            />
            {/* <input
              type="text"
              placeholder="Claim Number"
              value={noteForm.claimNumber}
              onChange={e => setNoteForm({ ...noteForm, claimNumber: e.target.value })}
            /> */}
            <input
              type="text"
              placeholder="Note"
              value={noteForm.note}
              onChange={e => setNoteForm({ ...noteForm, note: e.target.value })}
            />
            
            <button onClick={() => {
              // logger.log(typeof newNotes, Array.isArray(newNotes), newNotes);
              setNewNotes([...(newNotes || []), { ...noteForm, date: currentDate }]);
              handleAddNote(noteForm);
              setNoteForm({ note: '', biller: '' });
            }}>Add Note</button>
          </div>
        </div>
      </div>
    );
} else {
   return( 
    <div className='loading-claims'>
      <h3>Loading claims or no previous claims available...</h3>
      <GearsSpinner alt='Gears GIF' style={{ width: '200px', height: '200px' }}/>
    </div>
    
  )}
};
//Custom claims selector component to retrieve all of the claims from 
  const ClaimsSelector = () => { // value, onChange
    const { currentPatient } = useContext(GlobalStateContext);
    const [claimSelected, setClaimSelected] = useState([]);
    const { claimId, setClaimId } = useContext(BillingGlobalStateContext);
    const {currentUser} = useContext(GlobalStateContext);
    const user = getUserId(currentUser);
    const BASE_URL = process.env.REACT_APP_API_URL;
    useEffect(() => {
 
     const fetchPatientClaims = async () => {
          if (currentPatient) {
            try {
              const response = await fetch(`${BASE_URL}/billing/claimsSelector?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`)
              if (response.ok) {
                const data = await response.json();
                // logger.log("Data from claims: " + JSON.stringify(data));
                setClaimSelected(data.claimsData);
                }
            } catch (error) {
                logger.error("Error fetching claims", error);
            }
          } else {
            // window.alert("No patient selected.");
            }
        };
        fetchPatientClaims();

        }, []);

        const onChange = (value) => {
          if (setClaimId) { // Ensure it's available
              setClaimId(value);
          } else {
              logger.error("setClaimId is not defined!");
          }
      };


    return (
        <select onChange={(e) => onChange(e.target.value)}>
            <option value="">Select a claim</option> 
            {claimSelected.map(claim => (
                <option key={claim.claim_id} value={claim.claim_id} className='claim-selector' placeholder="Select a Claim">
                    {claim.claim_id} 
                </option>
            ))}
        </select>
    );
};

// Adjustments component with note-adding feature
const Adjustments = () => {
  const [previousClaims, setPreviousClaims] = useState([
    {
      patient_name: '',
      subscriber_full_address: '',
      subscriber_phone: '',
      outstanding_balance: ''
    }
  ]);
  const [previousAdjustment, setPreviousAdjustment] = useState([
    {
      id: '',
      claim_id: '',
      deposit_date: null,
      received_date: null,
      accounting_date: null,
      account_number: '',
      insurance_or_self: '',
      check_number: '',
      billed_claims_amount: '',
      adjustment_amount: '',
      allowed_amount: '',
      total_claim: '',
      met_deductible: '',
      patient_responsibility: '',
      insurance_payments: '',
      patient_copay: '',
      approved_or_denied: '',
      denial_reason: '',
      ris_patients_id: '',
      total_payments: '',
      outstanding_balance: ''

    }
  ]);
  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
  const { claimId } = useContext(BillingGlobalStateContext);
  const { patientId, claimNumber } = useParams();
  const [isEditing, setIsEditing] = useState(false);
  const [historyNotes, setHistoryNotes] = useState([]);
  const [noteForm, setNoteForm] = useState({ remit_number: '', note: '', biller: '' });
  const currentDate = new Date().toISOString().split('T')[0];
  const [patientName, setPatientName] = useState(null);
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const BASE_URL = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    if (patientName === null) {
      const getPatientName = async () => {
    try {
      const response = await fetch(`${BASE_URL}/billing/patientName?id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`);
        if (response.status === 200) {
          const data = await response.json();
          // logger.log(data)
          setPatientName(data.name);
        }
      } catch (error) {

      }
    }
    getPatientName();
  }
  }, [])
  
  useEffect(() => {
    const fetchClaims = async () => {
      if (currentPatient) {
        try {
          // logger.log(currentPatient)
          const response = await fetch(`${BASE_URL}/billing/getClaims?id=${currentPatient.patient[0].ris_patients_id}&claim_id=${claimId}&user=${user}&type=${currentUser.type}`);
          if (response.status === 200) {
            const data = await response.json();
            // logger.log("fetchClaims data: " + JSON.stringify(data))
            // logger.log('Demographics Data: ', data.demographics);
            // logger.log('Insured Data: ', data.insured);

            // Update state with BOTH pieces of data
            setPreviousClaims(data);
          }
        } catch (error) {
          logger.error("Error fetching claims", error);
        }
      } else {
        window.alert("No patient selected.");
      }
    };

    const fetchAdjustments = async () => { //ws
      
      if (currentPatient) {
        try {
          const response = await fetch(`${BASE_URL}/billing/adjustmentClaimDetails?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&claim_id=${claimId}&user=${user}&type=${currentUser.type}`
          );
          if (response.status === 200) {
            const data = await response.json();
            // logger.log('Adjustment claim details: ', JSON.stringify(data));

            // Update state with BOTH pieces of data
            setPreviousAdjustment(data.cp_data);
            setHistoryNotes(data.hn_data);
            // logger.log(historyNotes);
          }
        } catch (error) {
          logger.error("Error fetching claims", error);
        }
      } else {
        window.alert("No patient selected.");
      }
    }

    fetchClaims();
    fetchAdjustments();
  }, [claimId]); // Re-run when `currentPatient` changes

  const startEditing = () => {
    setIsEditing(true);
  };
// Handlers for updating state
  const handleDemographicsChange = (field, value) => {
    setPreviousClaims(prev => ({
      ...prev,
      demographics: prev.demographics?.map((demo, index) =>
        index === 0 ? { ...demo, [field]: value } : demo
      ) || prev.demographics,
    }));
  };

  const handleAdjustmentChange = (field, value) => {
    if (field === 'allowed_amount' || field === 'adjustment_amount') {
        const newValues = calculateAdjustmentValues(field, value, adjustment);
        setPreviousAdjustment(prev => {
        const updated = prev.map((adj, index) =>
          index === 0 ? { ...adj, ...newValues } : adj
        );
        // logger.log('Updated Adjustment:', updated);
        return updated;
      });
    } else {
      setPreviousAdjustment(prev => {
        const updated = prev.map((adj, index) =>
          index === 0 ? { ...adj, [field]: value } : adj
        );
        // logger.log('Updated Adjustment:', updated);
        return updated;
      });
    }
  };

  // Save changes to database
  const saveChanges = async () => {
    try {
      const updateClaim = async () => {
        try {
          const response = await fetch(`${BASE_URL}/billing/updateClaim?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({demographics: previousClaims.demographics, claimId}),
          });
            if (response.ok) {  
              const updatedData = await response.json();
              // logger.log("Updated claim: " + previousClaims)
              // logger.log('Claim updated successfully:', updatedData);
              setPreviousClaims( prev => ({...prev, ...updatedData})); // Apply updates to states
              // setTempDemographics(prev => ({ ...prev, ...updatedFields }));
              // setIsDirty(false);
          } else {
              // logger.log(JSON.stringify(previousClaims[0]))
              logger.error('Failed to update claim:', await response.json());
          }
        } catch (error) {
          logger.error('Error updating claim demographics:', error);
        }
      }

  const updateAdjustment = async () => {
    try {

    const normalizedAdjustment = {
      ...previousAdjustment[0],
      deposit_date: formatToLocalDate(previousAdjustment[0].deposit_date),
      received_date: formatToLocalDate(previousAdjustment[0].received_date),
      accounting_date: formatToLocalDate(previousAdjustment[0].accounting_date)
    };

     const response = await fetch(`${BASE_URL}/billing/UpdateAdjustment?user=${user}&type=${currentUser.type}`, {  //checking this out in backend
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(normalizedAdjustment),
        });

          if (response.ok) {
            const updatedData = await response.json();
            // logger.log(updatedData)
            // logger.log(updatedData.updatedFields.met_deductible)
            // Convert numeric response to string for UI
            const mappedAdjustment = {
              ...updatedData,
              // met_deductible: updatedData.updatedFields.met_deductible === 1 ? 'Yes' : updatedData.updatedFields.met_deductible === 0 ? 'No' : '',
            };

            // logger.log('Adjustment updated successfully:', mappedAdjustment);
            setPreviousAdjustment(prev => ({ ...prev, ...mappedAdjustment }));
          } else {
            // logger.log(JSON.stringify(previousAdjustment[0]))
            logger.error('Failed to update adjustment:', await response.json());
        }
    } catch (error) {
        logger.error('Error updating claim details:', error);
    }
  }

  updateAdjustment();
  updateClaim();

      window.alert("Changes saved successfully.");
    } catch (error) {
      logger.error("Error saving changes", error);
      window.alert("Failed to save changes. Please try again.");
    } finally {
      setIsEditing(false); // Revert to view mode on success or failure
    }
  };  
  
  let demographics;
  let adjustment;
  if (previousClaims?.demographics || previousClaims?.demographics?.length === 0) {
    demographics = previousClaims.demographics[0];
    adjustment = {};
    if(previousAdjustment){
      adjustment = previousAdjustment[0];
    }
  }

    //   function calculateAdjustmentValues(fieldChanged, value, currentValues) {
    //   const { allowed_amount, adjustment_amount, total_claim, outstanding_balance, total_payments } = currentValues;
    //   const parsedValue = parseFloat(value) || 0;
    //   const roundToTwo = num => Math.round((num + Number.EPSILON) * 100) / 100;
    //   let updatedValues = { ...currentValues };

    //   switch (fieldChanged) {
    //     case 'allowed_amount':
    //       updatedValues.allowed_amount = parsedValue;
    //       updatedValues.adjustment_amount = roundToTwo(total_claim - parsedValue);
    //       break;
    //     case 'adjustment_amount':
    //       updatedValues.adjustment_amount = parsedValue;
    //       updatedValues.allowed_amount = roundToTwo(total_claim - parsedValue);
    //       break;
    //     case 'total_claim':
    //       updatedValues.total_claim = parsedValue;
    //       if (allowed_amount !== null && !isNaN(allowed_amount)) {
    //         updatedValues.adjustment_amount = roundToTwo(parsedValue - allowed_amount);
    //       } else if (adjustment_amount !== null && !isNaN(adjustment_amount)) {
    //         updatedValues.allowed_amount = roundToTwo(parsedValue - adjustment_amount);
    //       }
    //       break;
    //     case 'outstanding_balance':
    //       updatedValues.outstanding_balance = parsedValue;

    //     default:
    //       break;
    //   }

    //   return updatedValues;
    // }

  function calculateAdjustmentValues(fieldChanged, value, currentValues) {
    const {
      allowed_amount,
      adjustment_amount,
      total_claim,
      total_payments = 0 // default to 0 if missing
    } = currentValues;

    const parsedValue = value === "" ? 0 : parseFloat(value);
    const roundToTwo = num => Math.round((num + Number.EPSILON) * 100) / 100;
    let updatedValues = { ...currentValues };

    switch (fieldChanged) {
      case 'allowed_amount':
        updatedValues.allowed_amount = parsedValue;
        updatedValues.adjustment_amount = roundToTwo(total_claim - parsedValue);
        break;

      case 'adjustment_amount':
        updatedValues.adjustment_amount = parsedValue;
        updatedValues.allowed_amount = roundToTwo(total_claim - parsedValue);
        break;

      case 'total_claim':
        updatedValues.total_claim = parsedValue;
        if (allowed_amount !== null && !isNaN(allowed_amount)) {
          updatedValues.adjustment_amount = roundToTwo(parsedValue - allowed_amount);
        } else if (adjustment_amount !== null && !isNaN(adjustment_amount)) {
          updatedValues.allowed_amount = roundToTwo(parsedValue - adjustment_amount);
        }
        break;

      case 'outstanding_balance':
        updatedValues.outstanding_balance = parsedValue;
        break;

      default:
        break;
    }

    // 👇 Final outstanding balance calculation
    updatedValues.outstanding_balance = roundToTwo(
      updatedValues.total_claim - updatedValues.adjustment_amount - total_payments
    );

    return updatedValues;
  }

 // && previousClaimsSummary?.length && setPreviousFinancialSummary?.length
  const handleAddHistoryNote =  async (noteForm) => {
    // if (previousClaims?.demographics?.length) { 
    // logger.log(JSON.stringify(noteForm))
      try {
        const response = await fetch(`${BASE_URL}/billing/historyNotes?claim_id=${claimId}&user=${user}&type=${currentUser.type}`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          },
          body: JSON.stringify(noteForm),
        });
        if (response.status === 200) {
          const data = await response.json();
          // logger.log("Added patient notes successfully: ")
          setHistoryNotes(data);
          // setPreviousAdjustment( prev => ({...prev, ...updatedData}));
        }
      } catch (error) {
        logger.error("Error adding patient notes", error);
        }
    // }
  }
  if (previousClaims?.demographics || previousClaims?.demographics?.length === 0) {
  return (
    <div className="ris-billing-adjustments">
      <BillingNavigation />
      <div className='claim-history-header'>
        <h2>Claim History for {demographics.patient_name || 'N/A'}</h2>
        <button className="PrimaryButton" onClick={isEditing ? saveChanges : startEditing}>
          {isEditing ? 'Save' : 'Edit'}
        </button>
        <ClaimsSelector />
      </div>
      {isEditing ? (
        <>
          <div className="ris-demographics">
            <p>
              <strong>Patient Name:</strong>{' '}
              <input
                type="text"
                name="patient_name"
                value={demographics.patient_name || ''}
                onChange={(e) => handleDemographicsChange('patient_name', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Subscriber Full Address:</strong>{' '}
              <input
                type="text"
                name="patient_address"
                value={demographics.patient_address || ''}
                onChange={(e) => handleDemographicsChange('patient_address', e.target.value)}
                className="ris-edit-input"
              />
              ,{' '}
              <input
                type="text"
                name="patient_city"
                value={demographics.patient_city || ''}
                onChange={(e) => handleDemographicsChange('patient_city', e.target.value)}
                className="ris-edit-input"
              />
              ,{' '}
              <input
                type="text"
                name="patient_state"
                value={demographics.patient_state || ''}
                onChange={(e) => handleDemographicsChange('patient_state', e.target.value)}
                className="ris-edit-input"
              />
              {' '}
              <input
                type="text"
                name="patient_zip"
                value={demographics.patient_zip || ''}
                onChange={(e) => handleDemographicsChange('patient_zip', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Subscriber Phone Number:</strong>{' '}
              <input
                type="text"
                name="patient_phone"
                value={demographics.patient_phone || ''}
                onChange={(e) => handleDemographicsChange('patient_phone', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            {/* <p>
              <strong>Outstanding Balance for Claim:</strong>{' '} 
              <input
                type="text"
                name="outstanding_balance"
                value={demographics.outstanding_balance || ''}
                onChange={(e) => handleDemographicsChange('outstanding_balance', e.target.value)}
                className="ris-edit-input"
              />
            </p> */}
            {/* <p>
              <strong>Patient Responsibility for Claim:</strong>{' '} 
              <input
                type="text"
                name="patient_responsibility"
                value={demographics.patient_responsibility || ''}
                onChange={(e) => handleDemographicsChange('patient_responsibility', e.target.value)}
                className="ris-edit-input"
              />
            </p> */}
          </div>

          <h3>Claim Details</h3>
          <div className="ris-billing-claim-details">
            <p>
              <strong>Claim Number:</strong>{' '}
              {/* <input
                type="text"
                name="claim_id"
                value={adjustment.claim_id || ''}
                onChange={(e) => handleAdjustmentChange('claim_id', e.target.value)}
                className="ris-edit-input"
              /> */}
              <span>{adjustment.claim_id || ''}</span>
            </p>
            <p>
              <strong>Account Number:</strong>{' '}
              {/* <input
                type="text"
                name="account_number"
                value={`HH${currentPatient.patient[0].ris_patients_id}`|| ''}
                onChange={(e) => handleAdjustmentChange('account_number', e.target.value)}
                className="ris-edit-input"
                //adjustment.account_number
              /> */}
              <span>HGI{currentPatient.patient[0].ris_patients_id}</span>
            </p>
            <p>
            <strong>Deposit Date:</strong>{' '}
            <input
              type="date"
              name="deposit_date"
              value={formatToLocalDate(adjustment.deposit_date) || null}
              onChange={(e) => handleAdjustmentChange('deposit_date', e.target.value)}
              className="ris-edit-input"
            />
            </p>
            <p>
              <strong>Total Charges:</strong>{' '}
              <input
                type="number"
                step="0.01"
                name="total_claim"
                value={adjustment.total_claim || ''}
                onChange={(e) => handleAdjustmentChange('total_claim', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Accounting Date:</strong>{' '}
              <input
                type="date"
                name="accounting_date"
                value={formatToLocalDate(adjustment.accounting_date) || null}
                onChange={(e) => handleAdjustmentChange('accounting_date', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Allowed Amount:</strong>{' '}
              <input
                type="number"
                step="0.01"
                name="allowed_amount"
                value={adjustment.allowed_amount || ''}
                onChange={(e) => handleAdjustmentChange('allowed_amount', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Date Received:</strong>{' '}
              <input
                type="date"
                name="received_date"
                value={formatToLocalDate(adjustment.received_date) || null}
                onChange={(e) => handleAdjustmentChange('received_date', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Adjustment Amount:</strong>{' '}
              <input
                type="number"
                step="0.01"
                name="adjustment_amount"
                value={adjustment.adjustment_amount || ''}
                onChange={(e) => handleAdjustmentChange('adjustment_amount', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Check Number:</strong>{' '}
              <input
                type="text"
                name="check_number"
                value={adjustment.check_number || ''}
                onChange={(e) => handleAdjustmentChange('check_number', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Insurance Payments:</strong>{' '}
              <input
                type="number"
                name="insurance_payments"
                value={adjustment.insurance_payments || ''}
                onChange={(e) => handleAdjustmentChange('insurance_payments', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Patient Copay:</strong>{' '}
              <input
                type="number"
                name="patient_copay"
                value={adjustment.patient_copay || ''}
                onChange={(e) => handleAdjustmentChange('patient_copay', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Patient Responsibility:</strong>{' '}
              <input
                type="number"
                name="patient_responsibility"
                value={adjustment.patient_responsibility || ''}
                onChange={(e) => handleAdjustmentChange('patient_responsibility', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            

              <p>
              <strong>Insurance Or Self Pay:</strong>{' '}
              <select
                name="insurance_or_self"
                value={adjustment.insurance_or_self || ""}
                onChange={(e) => handleAdjustmentChange('insurance_or_self', e.target.value)}
                className="ris-edit-input"
              >
                <option value="">Select</option>
                <option value="Insurance">Insurance</option>
                <option value="Self">Self</option>
              </select>
            </p>
            <div></div>
           
            
            
            
            <div>
              <strong>Approved or Denied:</strong>{' '}
              <select
                value={adjustment.approved_or_denied == 1 ? "Approved" : "Denied"}
                onChange={(e) => handleAdjustmentChange(
                  'approved_or_denied',
                  e.target.value === "Approved" ? 1 : 0
                )}
                className="patient-type-select"
              >
                <option value="Approved">Approved</option>
                <option value="Denied">Denied</option>
              </select>
              {adjustment.approved_or_denied == 0 ?
              <div>
                <p><strong>Reason:</strong></p>
                <input
                  type="text"
                  name="denial_reason"
                  value={adjustment.denial_reason || ''}
                  onChange={(e) => handleAdjustmentChange('denial_reason', e.target.value)}
                  className="ris-edit-input"
                />
                </div>
              : null}
            </div>
          </div>
            <div className='claim-history-payment-info'>
            <p>
              <strong>Total Payments:</strong>{' '}
              <input
                type="number"
                name="total_payments"
                value={adjustment.total_payments || ''}
                onChange={(e) => handleAdjustmentChange('total_payments', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            <p>
              <strong>Outstanding Balance:</strong>{' '}
              <input
                type="number"
                name="outstanding_balance"
                value={adjustment.outstanding_balance || ''}
                onChange={(e) => handleAdjustmentChange('outstanding_balance', e.target.value)}
                className="ris-edit-input"
              />
            </p>
            </div>

          <div className="ris-billing-adjustments-notes">
            <h3>Notes for Claim {claimNumber}</h3>
            <table>
              <thead>
                <tr>
                  <th>Biller</th>
                  <th>Remit Number</th>
                  <th>Date</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                {historyNotes?.length > 0 ? historyNotes.map((note, index) => (
                  <tr key={index}>
                    <td>{note.biller || 'N/A'}</td>
                    <td>{note.remit_number || 'N/A'}</td>
                    <td>{dateOfBirth(note.date) || 'N/A'}</td>
                    <td>{note.note || 'N/A'}</td>
                  </tr>
                )) : null }
              </tbody>
            </table>
            <div className="ris-billing-add-note">
              <h4>Add Note for Claim {claimNumber}</h4>
              <input
                type="text"
                placeholder="Biller"
                value={noteForm.biller}
                onChange={(e) => setNoteForm({ ...noteForm, biller: e.target.value })}
              />
              <input
                type="text"
                placeholder="Remit Number"
                value={noteForm.remit_number}
                onChange={(e) => setNoteForm({ ...noteForm, remit_number: e.target.value })}
              />
              <input
                type="text"
                placeholder="Note"
                value={noteForm.note}
                onChange={(e) => setNoteForm({ ...noteForm, note: e.target.value })}
              />
              <button
                onClick={() => {
                  // logger.log("Button clicked!");
                  setHistoryNotes([...historyNotes, { ...noteForm, date: currentDate }]);
                  handleAddHistoryNote(noteForm);
                  saveChanges();
                  setNoteForm({ remit_number: '', note: '', biller: '' });
                }}
              >
                Add Note
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="ris-demographics">
          <p><strong>Patient Name:</strong> {demographics.patient_name || 'N/A'}</p>
          <p>
            <strong>Subscriber Full Address:</strong>{' '}
            {demographics.patient_address || 'N/A'}, {demographics.patient_city || 'N/A'},{' '}
            {demographics.patient_state || 'N/A'} {demographics.patient_zip || 'N/A'}
          </p>
          <p><strong>Subscriber Phone Number:</strong> {demographics.patient_phone || 'N/A'}</p>
          {/* <p><strong>Outstanding Balance:</strong> ${(demographics.outstanding_balance || 0).toFixed(2)}</p> */}
          {/* <p><strong>Patient Responsibility For Claim:</strong> Not Known ATM</p> */}

          <h3>Claim Details</h3>
          <div className="ris-billing-claim-details">
            <p><strong>Claim Number:</strong> {adjustment.claim_id || 'N/A'}</p>
            <p><strong>Account Number:</strong> {`HH${currentPatient.patient[0].ris_patients_id}` || 'N/A'}</p>
            <p><strong>Deposit Date:</strong> {dateOfBirth(adjustment.deposit_date) || 'N/A'}</p>
            <p><strong>Total Charges:</strong> ${adjustment.total_claim || 'N/A'}</p>
            <p><strong>Accounting Date:</strong> {dateOfBirth(adjustment.accounting_date) || 'N/A'}</p>
            <p><strong>Allowed Amount:</strong> ${adjustment.allowed_amount || 'N/A'}</p>
            <p><strong>Date Received:</strong> {dateOfBirth(adjustment.received_date) || 'N/A'}</p>
            <p><strong>Adjustment Amount:</strong> ${adjustment.adjustment_amount || 'N/A'}</p>
            <p><strong>Check Number:</strong> {adjustment.check_number || 'N/A'}</p>
            <p><strong>Insurance Payments:</strong> ${adjustment.insurance_payments || 'N/A'}</p>
            <p><strong>Patient Copay:</strong> ${adjustment.patient_copay || 'N/A'}</p>
            <p><strong>Patient Responsibility:</strong> ${adjustment.patient_responsibility || 'N/A'}</p>
            
            <p><strong>Insurance or Self Pay:</strong> {adjustment.insurance_or_self || 'N/A'}</p>
            <p></p>
            {/* <p><strong>Billed Claims Amount:</strong> ${adjustment.billed_claims_amount || 'N/A'}</p> */}
              
            
            
          
            {/* <p><strong>Met Deductible:</strong> {adjustment.met_deductible || "N/A"}</p> */}
            
            
            <p><strong>Approved or Denied:</strong> {adjustment.approved_or_denied == 1 ? "Approved" : "Denied"}</p>
            {adjustment.approved_or_denied == 0 ? (<> <br/> <p><strong>Reason:</strong> {adjustment.denial_reason || ''} </p></>) : null}
          </div>
            
            <div className='claim-history-payment-info'>
            <p><strong>Total Payments:</strong>${adjustment.total_payments || 'N/A'}</p>
            <p><strong>Outstanding Balance:</strong>${adjustment.outstanding_balance || 'N/A'}</p>
            </div>

          <div className="ris-billing-adjustments-notes">
            <h3>Notes for Claim {claimId}</h3>
            <table>
              <thead>
                <tr>
                  <th>Biller</th>
                  <th>Remit Number</th>
                  <th>Date</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                {historyNotes ? historyNotes.map((note, index) => (
                  <tr key={index}>
                    <td>{note.biller || 'N/A'}</td>
                    <td>{note.remit_number || 'N/A'}</td>
                    <td>{dateOfBirth(note.date) || 'N/A'}</td>
                    <td>{note.note || 'N/A'}</td>
                  </tr>
                )) : null}
              </tbody>
            </table>
            <div className="ris-billing-add-note">
              <h4>Add Note for Claim {claimId}</h4>
              <input
                type="text"
                placeholder="Biller"
                value={noteForm.biller}
                onChange={(e) => setNoteForm({ ...noteForm, biller: e.target.value })}
              />
              <input
                type="text"
                placeholder="Remit Number"
                value={noteForm.remit_number}
                onChange={(e) => setNoteForm({ ...noteForm, remit_number: e.target.value })}
              />
              <input
                type="text"
                placeholder="Note"
                value={noteForm.note}
                onChange={(e) => setNoteForm({ ...noteForm, note: e.target.value })}
              />
              <button
                onClick={() => {
                  setHistoryNotes([...historyNotes, { ...noteForm, date: currentDate }]);
                  handleAddHistoryNote(noteForm);
                  setNoteForm({ remit_number: '', note: '', biller: '' });
                }}
              >
                Add Note
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} else {
  // logger.log(currentPatient)
  return (
  <div className="ris-billing-adjustments">
      <BillingNavigation />
      <div className='claim-history-header'>
        <h2>Claim History for {patientName}</h2>
        <div className='claim-history-header'>
          <h2>Select a Claim to View</h2>
            <div>
              <ClaimsSelector />
            </div>
        </div>
      </div>
  </div>
  )
}
};
// PatientSummary component with updated summary table and note-adding feature
const PatientSummary = () => {
  const [previousClaims, setPreviousClaims] = useState([]);
  const [previousClaimsSummary, setPreviousClaimsSummary] = useState([]);
  const [previousFinancialSummary, setPreviousFinancialSummary] = useState([]);
  const [totalAdjustments, setTotalAdjustments] = useState(0.00);
  const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
  const { outstandingBalance, setOutstandingBalance, fetchOutstandingBalance, fetchPatientResponsibility } = useContext(BillingGlobalStateContext);
  const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);  
  const { claimId, setclaimId } = useContext(BillingGlobalStateContext);
  const { patientId } = useParams();
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  // const patient = patients.find(p => p.patientId === parseInt(patientId));
  const [patientNotes, setPatientNotes] = useState([]);
  const [noteForm, setNoteForm] = useState({ note: '', biller: '' });
  const currentDate = new Date().toISOString().split('T')[0];
  const BASE_URL = process.env.REACT_APP_API_URL;
  // if (!patient) return <div>Patient not found</div>;

  // const patientClaims = claims.filter(c => c.patientId === patient.patientId);
  // const subscriber = patient.primaryInsurance?.subscriber || {};

    useEffect(() => {
    const fetchClaims = async () => {
      if (currentPatient) {
        try {
          // logger.log(currentPatient)
            const response = await fetch(`${BASE_URL}/billing/getPatientsClaims?id=${currentPatient.patient[0].ris_patients_id}&claim_id=${claimId}&user=${user}&type=${currentUser.type}`);          
            if (response.status === 200) {
            const data = await response.json();
            // logger.log('data ', data)
            // logger.log('Demographics Data: ', data.demographics);
            // logger.log('Insured Data: ', data.insured);

            // Update state with BOTH pieces of data
            setPreviousClaims(data);
          }
        } catch (error) {
          logger.error("Error fetching claims", error);
        }
      } else {
        window.alert("No patient selected.");
      }
    };

    const fetchSummaries = async () => {
      if (currentPatient) {
        try {
          const response = await fetch(`${BASE_URL}/billing/patientSummaries?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`);
          if (response.status === 200) {
            const data = await response.json();
            // logger.log('Patient summaries' + JSON.stringify(data))
            // logger.log('Claims Summary ' + data.ps_data[0])
            //logger.log('Financial Summary ' + JSON.stringify(data.fs_data[0]))

            // Update state with BOTH pieces of data
            setPreviousClaimsSummary(data.ps_data);
            setPreviousFinancialSummary(data.fs_data[0]);
            setTotalAdjustments(data.ta_data[0].total_adjustments)
            setPatientNotes(data.pn_data);
            // logger.log(JSON.stringify(patientNotes))
          }
        } catch (error) {
          logger.error("Error fetching claims", error);
        }
      } else {
        window.alert("No patient selected.");
      }
    };

    fetchClaims();
    fetchSummaries();
    fetchPatientResponsibility();
    fetchOutstandingBalance();
  }, []); // Re-run when `currentPatient` changes
  
  //does previous claims exist
  if (previousClaims?.demographics?.length) { // && previousClaimsSummary?.length && setPreviousFinancialSummary?.length

  const handleAddNote = async (noteForm) => {
    try {
          const response = await fetch(`${BASE_URL}/billing/patientNotes?ris_patients_id=${currentPatient.patient[0].ris_patients_id}&user=${user}&type=${currentUser.type}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(noteForm),
          });
          if (response.status === 200) {
            const data = await response.json();
            logger.log("Added patient notes successfully: ")
            setPatientNotes(data);
            // setPreviousAdjustment( prev => ({...prev, ...updatedData}));
          }
        } catch (error) {
          logger.error("Error adding patient notes", error);
        }
  }
  // logger.log("Previous claims summary: ", previousClaimsSummary[0].met_deductible)
  
    return (
      <div className="ris-billing-patient-summary">
        <BillingNavigation />
        <h2>Patient Summary for {previousClaims?.demographics[0]?.patient_name}</h2>
        <p><strong>Patient Name:</strong> {previousClaims?.demographics[0]?.patient_name}</p>
        <p><strong>Subscriber Full Address:</strong> {previousClaims?.demographics[0]?.patient_address}, {previousClaims.demographics[0].patient_city}, {previousClaims.demographics[0].patient_state} {previousClaims.demographics[0].patient_zip}</p>
        <p><strong>Subscriber Phone Number:</strong> {previousClaims?.demographics[0]?.patient_phone}</p>
        <p><strong>Outstanding Balance:</strong> ${outstandingBalance}</p>
        <p><strong>Patient Responsibility:</strong> ${patientResponsibility} </p>
        {/* <p><strong>Subscriber Name:</strong> {subscriber.firstName} {subscriber.lastName}</p> */}
        <h3>Summary of Claims</h3>
        <table className="ris-billing-claims-table">
          <thead>
            <tr>
              <th>Claim Number</th>
              <th>Claim Date</th>
              <th>Copay Amount</th>
              <th>Patient Responsibility</th>
              <th>Total Claim</th>
              {/* <th>Open or Final</th> */}
            </tr>
          </thead>
           <tbody>
            {previousClaimsSummary?.map(claim => (
              <tr key={claim.claim_id}>
                <td>{claim.claim_id}</td>
                <td>{dateOfBirth(claim.created_at)}</td>
                <td>${claim.patient_copay}</td>
                <td>${claim.patient_responsibility}</td>
                <td>${claim.total_claim}</td>
                {/* <td>{claim.open_or_final ? "Open" : "Final"}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
        <h3>Financial Summary</h3>
        <table className="ris-billing-summary-table">
          <thead>
            <tr>
              {/* <th>Deductible Met</th> */}
              <th>Outstanding Patient Bal.</th>
              <th>Total Patient Paid</th>
              <th>Total Insurance Paid</th>
              <th>Total Adjustments</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {/* <td>{previousClaimsSummary[0]?.met_deductible == 1 ? 'Yes' : 'No'}</td> */}
              <td>${outstandingBalance}</td>
              <td>${previousFinancialSummary?.total_patient_paid ? previousFinancialSummary?.total_patient_paid : 0.00}</td>
              <td>${previousFinancialSummary?.total_insurance_paid ? previousFinancialSummary?.total_insurance_paid : 0.00}</td>
              <td>${totalAdjustments}</td>
            </tr>
          </tbody>
        </table>
        <div className="ris-billing-patient-notes">
          <h3>Patient Notes</h3>
          <table>
            <thead>
              <tr>
                  <th>Biller</th>
                  <th>Date</th>
                  <th>Note</th>
                
              </tr>
            </thead>
            <tbody>
              
              {patientNotes.map((note, index) => (
                <tr key={index}>
                  <td>{note.biller || "N/A"}</td>
                  <td>{dateOfBirth(note.date)}</td>
                  <td>{note.note}</td>
                  
                </tr>
              ))}
            </tbody>
          </table>
          <div className="ris-billing-add-note">
            <h4>Add Note</h4>
            <input
              type="text"
              placeholder="Biller"
              value={noteForm.biller}
              onChange={e => setNoteForm({ ...noteForm, biller: e.target.value })}
            />
            <input
              type="text"
              placeholder="Note"
              value={noteForm.note}
              onChange={e => setNoteForm({ ...noteForm, note: e.target.value })}
            />
            
            <button onClick={() => {
              setPatientNotes([...patientNotes, { ...noteForm, date: currentDate }]);
              handleAddNote(noteForm);
              setNoteForm({ note: '', biller: '' });
              
            }}>Add Note</button>
          </div>
        </div>
      </div>
    );
    } else {
    return( 
    <div className='loading-claims'>
      <h3>Loading claims or no previous claims available...</h3>
      <GearsSpinner alt='Gears GIF' style={{ width: '200px', height: '200px' }}/>
    </div>
    
  )}
};

// ClaimsSummary component with sorting functionality and filtering by days
const ClaimsSummary = () => {
  const {currentUser} = useContext(GlobalStateContext);
  const user = getUserId(currentUser);
  const BASE_URL = process.env.REACT_APP_API_URL;
  const [sortedClaims, setSortedClaims] = useState([
    {
      id: '',
      created_at: '',
      patient_name: '',
      patient_responsibility: '',
      total_claim: '',
      remit_number: ''
    }
  ]);
  const [sortedClaimsCopy, setSortedClaimsCopy] = useState([
    {
      id: '',
      created_at: '',
      patient_name: '',
      patient_responsibility: '',
      total_claim: '',
      remit_number: ''
    }
  ]);
  const [filterDays, setFilterDays] = useState("all");
  // const { outstandingBalance, setOutstandingBalance } = useContext(BillingGlobalStateContext);
  // const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);  

  useEffect(() => {

    const claimsSummaryData = async () => {
      try{
        const response = await fetch(`${BASE_URL}/billing/claimsSummary?user=${user}&type=${currentUser.type}`)
          if (response.status === 200){
            const data = await response.json()
            // logger.log(JSON.stringify(data))
            setSortedClaims(data)
            setSortedClaimsCopy(data)
          }
        }
        catch (error){
          logger.error(`Could not fetch claims`)
        }
    }

    claimsSummaryData();
  }, []);

  useEffect(() => {
  filterDates();
}, [filterDays]);

  const filterDates = () => {
      const now = Date.now();

      setSortedClaimsCopy(sortedClaims);

      const filtered = sortedClaims.filter(claim => {
        const claimDate = new Date(claim.created_at).getTime();

        if (filterDays === "olderThan120") {
          return now - claimDate > 120 * 24 * 60 * 60 * 1000;
        }

        if (filterDays === "all") {
          return claim.created_at;
        }

        if (!filterDays) return true;

        return now - claimDate <= filterDays * 24 * 60 * 60 * 1000;
      });

      // Ensure you're sorting by the correct, existing field
      const sorted = [...filtered].sort((a, b) => 
        new Date(a.created_at) - new Date(b.created_at)
      );
      // logger.log(sorted)

      setSortedClaimsCopy(sorted);
    }

  return (
    <div className="ris-billing-claims-summary">
      <BillingNavigation />
      <h2>Claims Summary</h2>
      <div>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(30)}>Last 30 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(60)}>Last 60 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(90)}>Last 90 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(120)}>Last 120 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays("olderThan120")}>Older than 120 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays("all")}>All</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Claim Number</th>
            <th>Claim Date</th>
            <th>Patient Name</th>
            <th>Patient Responsibility</th>
            <th>Total Claim</th>
            <th>Remit Numbers</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            // Group claims by claim_id
            const claimMap = new Map();
            sortedClaimsCopy.forEach((claim) => {
              if (!claimMap.has(claim.claim_id)) {
                claimMap.set(claim.claim_id, []);
              }
              claimMap.get(claim.claim_id).push(claim);
            });

            // Render one row per unique claim_id
            return Array.from(claimMap.entries()).map(([claim_id, groupedClaims]) => {
              const baseClaim = groupedClaims[0]; // Use the first for consistent info
              const remitNumbers = groupedClaims
                .map(claim => claim.remit_number) // Extract remit_number from groupedClaims
                .filter(Boolean); // Removes null/undefined if needed

              return (
                <tr key={claim_id || `${baseClaim.patient_name}-${baseClaim.created_at}`}>
                  <td>{claim_id}</td>
                  <td>{dateOfBirth(baseClaim.created_at)}</td>
                  <td>{baseClaim.patient_name}</td>
                  <td>${baseClaim.patient_responsibility}</td>
                  <td>${baseClaim.total_claim}</td>
                  <td>{remitNumbers.length > 0 ? remitNumbers.join(', ') : 'N/A'}</td>
                </tr>
              );
            });
          })()}
        </tbody>
      </table>
    </div>
  );
};

// DenialsSummary component with filtering functionality
const DenialsSummary = () => {
    const {currentUser} = useContext(GlobalStateContext);
    const user = getUserId(currentUser);
    const BASE_URL = process.env.REACT_APP_API_URL;
  const [sortedClaims, setSortedClaims] = useState([
    {
      id: '',
      insured_name: '',
      patient_name: '',
      exam: '',
      cpt_code: '',
      denial_reason: '',
      biller: '',
      created_at: ''
    }
  ]);
  const [sortedClaimsCopy, setSortedClaimsCopy] = useState([
    {
      id: '',
      insured_name: '',
      patient_name: '',
      exam: '',
      cpt_code: '',
      denial_reason: '',
      biller: '',
      created_at: ''
    }
  ]);
  const [filterDays, setFilterDays] = useState("all");

  useEffect(() => {
    const denialsSummaryData = async () => {
      try{
        const response = await fetch(`${BASE_URL}/billing/denialsSummary?user=${user}&type=${currentUser.type}`)
          if (response.status === 200){
            const data = await response.json()
            // logger.log(JSON.stringify(data))
            setSortedClaims(data)
            setSortedClaimsCopy(data)
          }
        }
        catch (error){
          logger.error(`Could not fetch claims`)
        }
    }
    denialsSummaryData();

  }, []);

  useEffect(() => {
  filterDates();
}, [filterDays]);

  const filterDates = () => {
      const now = Date.now();

      setSortedClaimsCopy(sortedClaims);

      const filtered = sortedClaims.filter(claim => {
        const claimDate = new Date(claim.created_at).getTime();

        if (filterDays === "olderThan120") {
          return now - claimDate > 120 * 24 * 60 * 60 * 1000;
        }

        if (filterDays === "all") {
          return claim.created_at;
        }

        if (!filterDays) return true;

        return now - claimDate <= filterDays * 24 * 60 * 60 * 1000;
      });

      // Ensure you're sorting by the correct, existing field
      const sorted = [...filtered].sort((a, b) => 
        new Date(a.created_at) - new Date(b.created_at)
      );
      // logger.log(sorted)

      setSortedClaimsCopy(sorted);
    }

  return (
    <div className="ris-billing-denials-summary">
      <BillingNavigation />
      <h2>Denials Summary</h2>
      <div>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(30)}>Last 30 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(60)}>Last 60 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(90)}>Last 90 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays(120)}>Last 120 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays("olderThan120")}>Older than 120 Days</button>
        <button className='ris-billing-summary-sort' onClick={() => setFilterDays("all")}>All</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Claim Number</th>
            <th>Claim Date</th>
            <th>Patient Name</th>
            <th>Payor</th>
            <th>Exam Description</th>
            <th>CPT</th>
            <th>Reason</th>
            <th>Biller</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
  // Group denials by claim_id
  const denialMap = new Map();
  sortedClaimsCopy.forEach(claim => {
    if (!denialMap.has(claim.claim_id)) {
      denialMap.set(claim.claim_id, []);
    }
    denialMap.get(claim.claim_id).push(claim);
  });

  // Render one row per unique claim_id
  return Array.from(denialMap.entries()).map(([claim_id, groupedClaims], index) => {
    const baseClaim = groupedClaims[0]; // Use the first claim for display consistency

    // Collect all CPT codes, filter out falsy values, and remove duplicates
    const cptCodes = Array.from(new Set(
      groupedClaims.map(c => c.cpt_code).filter(Boolean)
    ));

    return (
      <tr key={claim_id || index}>
        <td>{claim_id || "N/A"}</td>
        <td>{dateOfBirth(baseClaim.created_at) || "N/A"}</td>
        <td>{baseClaim.patient_name || "N/A"}</td>
        <td>{baseClaim.insured_name || "N/A"}</td>
        <td>{baseClaim.exam || "N/A"}</td>
        <td>{cptCodes.length > 0 ? cptCodes.join(', ') : "N/A"}</td>
        <td>{baseClaim.denial_reason || "N/A"}</td>
        <td>{baseClaim.biller || "N/A"}</td>
      </tr>
    );
  });
})()}

        </tbody>
      </table>
    </div>
  );
};
//
// Main component
const Billing = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [patients, setPatients] = useState([]);
    const navigate = useNavigate();
    const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
    const {currentUser} = useContext(GlobalStateContext);
    const user = getUserId(currentUser);

    const handleSearch = async (query) => {
        setSearchQuery(query);
        // logger.log('query', query)
        // Debounce search to avoid too many API calls
        //need to add search button to make less API calls
        const results = await api.searchPatientsApi(query, currentUser, user);
        // logger.log('results:', results)
        setPatients(results);
      };

  return (

    <div>
    <div className="ris-billing-container">
        
      <Routes>
        <Route path="/generate" element={<Claims />} />
        <Route path="/adjustments" element={<Adjustments />} />
        <Route path="/patient-summary" element={<PatientSummary />} />
        <Route path="/claims-summary" element={<ClaimsSummary />} />
        <Route path="/denials-summary" element={<DenialsSummary />} />
        <Route path="/worklist" element={<Worklist />} />
        <Route path="/" element={<div><BillingNavigation />
        <div>Select patient from search:</div>
        <div className="search-patient">
          <input
            type="text"
            placeholder="Search Patient"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} // This does work so far
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                  // Your search logic here
                  handleSearch(searchQuery);
              }
            }}
            className="search-input"
          />
          <button className='search-button' onClick={() => handleSearch(searchQuery)}>Search</button>
          </div>
              <ul className="patient-list">
              {patients.map((patient) => (
                <li
                  key={patient.ris_patients_id}
                  onClick={() => {setCurrentPatient(prev => ({
                                                    ...prev,
                                                    patient: [{ ...prev?.patient?.[0], ris_patients_id: patient.ris_patients_id }]
                                                    })); navigate(`/billing/patient-summary`)}}//generate/${patient.ris_patients_id}
                  className="patient-item"
                >
                  {patient.first_name} {patient.last_name} | {dateOfBirth(patient.date_of_birth)} | {patient.address} 
                </li>
              ))}
            </ul>
          
        </div>} />
      </Routes>
    </div>
    </div>
  );
};

export default Billing;

// // Create the context
// export const BillingGlobalStateContext = createContext();
// export const BillingGlobalStateProvider = ({ children }) => {

//   const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
//   const [outstandingBalance, setOutstandingBalance] = useState('0.00');
//   const [patientResponsibility, setPatientResponsibility] = useState('0.00');
//   const [claimId, setClaimId] = useState("");
//   const BASE_URL = process.env.REACT_APP_API_URL;

//     useEffect(() => {
//       if(currentPatient) {
//       const fetchOutstandingBalance = async () => {
//             try {
//                 const response = await fetch(`${BASE_URL}/billing/outstandingBalance?ris_patients_id=${currentPatient.ris_patients_id}`);
//                 if (response.status === 200) {
//                 const data = await response.json();
//                 logger.log("Outstanding balance: " + JSON.stringify(data.total_due));
//                 setOutstandingBalance(data.total_due);
//                 }
//             } catch (error) {
//                 logger.error("Error fetching claims", error);
//             }

//         };
      
//         const fetchPatientResponsibility = async () => {
//           if (currentPatient) {
//             try {
//               const response = await fetch(`${BASE_URL}/billing/patientResponsibility?ris_patients_id=${currentPatient.ris_patients_id}`)
//               if (response.status === 200) {
//                 const data = await response.json();
//                 logger.log("Patient responsibility: ", data.total_responsibility)
//                 setPatientResponsibility(data.total_responsibility);
//                 }
//             } catch (error) {
//                 logger.error("Error fetching claims", error);
//             }
//           } else {
//             window.alert("No patient selected.");
//             }
//         }

//         fetchOutstandingBalance();
//         fetchPatientResponsibility();
//       }

//     }, []);

//     return (
//         <BillingGlobalStateContext.Provider value={{ outstandingBalance, setOutstandingBalance, patientResponsibility, setPatientResponsibility, claimId, setClaimId }}>
//             {children}
//         </BillingGlobalStateContext.Provider>
//     );
// };

// // Hard-coded data
// const api = {
    
//     searchPatientsApi: async (query) => {
//         try {

//           const newQry = query
//           logger.log('nq', newQry)
//           const response = await fetch(`${BASE_URL}/billing/claims?pNames=${newQry} `)  
//           if (response.status === 200) {
//             const data = await response.json();
//             logger.log(data);
//             return data
//           } 
//           else if (response.status === 404){
//             logger.error('Error: Not Found 404');
//           }
//           else if (response.status === 500){
//             logger.error('Error: Internal Server Error 500');
//           }
//         }
//         catch (error) {
//           logger.error('Error fetching patients:', error);
//         };
      
//     }
// }

// // Navigation component used across all pages
// const BillingNavigation = () => {
//   const navigate = useNavigate();

//   const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext); 
 

//   // if no patient id, show only the home button to go back
//   if (!currentPatient){
//     return (
//     <div>
//       <div>
//         <UserDetails></UserDetails>
        
//       </div>
//     <nav className="ris-billing-nav">
//       <button onClick={() => navigate('/home')}>Back to Home</button>
//       <button onClick={() => navigate('/billing/claims-summary')}>Claims Summary</button>
//       <button onClick={() => navigate('/billing/denials-summary')}>Denials Summary</button>
//     </nav>
//     </div>
//     );

//   } else {
//   //if you have patient id, you can see all of the pages
//   return (
//     <div>
//       <div>
//         <UserDetails></UserDetails>
//       </div>
//     <nav className="ris-billing-nav">
//       <button onClick={() => navigate('/home')}>Back to Home</button>
//       <button onClick={() => navigate('/generateClaim')}>Generate Claim</button>
//       <button onClick={() => navigate('/billing/generate/'+currentPatient.ris_patients_id)}>Claims</button>
//       <button onClick={() => navigate('/billing/adjustments')}> Claim History/Adjustments</button>
//       <button onClick={() => navigate('/billing/patient-summary')}>Patient Summary</button>
//       <button onClick={() => navigate('/billing/claims-summary')}>Claims Summary</button>
//       <button onClick={() => navigate('/billing/denials-summary')}>Denials Summary</button>
//     </nav>
//     </div>
//   );
//   };
// }

// // Claims component with note-adding feature 
// const Claims = () => {
//   const [previousClaims, setPreviousClaims] = useState([]);
//   const { outstandingBalance, setOutstandingBalance } = useContext(BillingGlobalStateContext);
//   const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);
//   const { claimId, setclaimId } = useContext(BillingGlobalStateContext);
//   const BASE_URL = process.env.REACT_APP_API_URL;

//   const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);  
//   const [newNotes, setNewNotes] = useState([]);
//   const [noteForm, setNoteForm] = useState({ note: '', biller: '' });
//   const currentDate = new Date().toISOString().split('T')[0];

//   useEffect(() => {
//   const fetchClaims = async () => {
//     if (currentPatient) {
//       try {
//         logger.log(currentPatient)
//         const response = await fetch(`${BASE_URL}/billing/getClaims?id=${currentPatient.ris_patients_id}&claim_id=${claimId}`);
//         if (response.status === 200) {
//           const data = await response.json();
//           setPreviousClaims(data);
//         }
//       } catch (error) {
//         logger.error("Error fetching claims", error);
//       }
//     } else {
//       window.alert("No patient selected.");
//     }
//   };
//   const fetchClaimNote = async () => {
//     if (currentPatient) {
//       try{
//         const response = await fetch(`${BASE_URL}/billing/getClaimNotes?ris_patients_id=${currentPatient.ris_patients_id}`);
//         const data = await response.json();
//         setNewNotes(data);
        
//       } catch (error) {
//         logger.error(error);
//       }
//     } else {
//         window.alert("No patient selected.");
//       }
//   };

//   fetchClaims();
//   fetchClaimNote();
// }, []); // Re-run when `currentPatient` changes

//  const handleAddNote = async (noteForm) => {
//     if (currentPatient) {
//       try {
//         const response = await fetch(`${BASE_URL}/billing/claimNotes?ris_patients_id=${currentPatient.ris_patients_id}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(noteForm),
//           });
//         if (response.ok) {
//           const data = await response.json();
//           logger.log(data)
//           setNewNotes(data); // test this line
//         }
//       } catch (err) {
//         logger.error("Error message: ", err)
//       }
//     } else {
//       window.alert("No patient selected.");
//     }
//  }

//   const renderInsurance = () => {
//     logger.log("Previous Claims: " + JSON.stringify(previousClaims.insured));
//     let payorArray = ["Primary Payor", "Secondary Payor", "Tertiary Payor"];
//     return (previousClaims?.insured?.length) ? (
//     <div>
//       {previousClaims.insured.map((claim, i) => (
//         <div className="ris-billing-insurance-section">
//           <h3>{payorArray[i]}</h3><br/>
//             <div key={i}>
//               <p><strong>Insurance Name:</strong> {claim.insurance_name}</p>
//               <p><strong>Insurance Full Address:</strong> {claim.insurance_address}</p>
//               <p><strong>Insurance Phone Number:</strong> {claim.insurance_phone}</p>
//               <p><strong>Insurance Member ID:</strong> {claim.member_id}</p>
//               <p><strong>Insurance Group:</strong> {claim.group_number}</p>
//               <p><strong>Effective Date:</strong> {dateOfBirth(claim.effective_date)}</p>
//               <p><strong>Termination Date:</strong> {dateOfBirth(claim.termination_date)}</p>
//               <p><strong>Subscriber Full Name:</strong> {claim.subscriber_name}</p>
//               <p><strong>Subscriber DOB:</strong> {dateOfBirth(claim.subscriber_dob)}</p>
//               <p><strong>Subscriber Relationship:</strong> {claim.relationship}</p>
//             </div>
//           </div>
//           ))}
//       </div>
//   ) : null};

//   if (previousClaims?.demographics?.length) {
//     return (
//       <div className="ris-billing-generate-claim">
//         <BillingNavigation />
//         <div className="ris-billing-generate-claim-header">
//           <h2>Claim Information for {previousClaims.demographics[0].patient_name}</h2>
//           <Link to="/generateClaim" ><button className='ris-bigger-blue-button'>Generate New Claim</button></Link>
//         </div>
//         <p><strong>Patient Name:</strong> {previousClaims.demographics[0].patient_name}</p>
//         <p><strong>Subscriber Full Address:</strong> {previousClaims.demographics[0].patient_address}, {previousClaims.demographics[0].patient_city}, {previousClaims.demographics[0].patient_state} {previousClaims.demographics[0].patient_zip}</p>
//         <p><strong>Subscriber Phone Number:</strong> {previousClaims.demographics[0].patient_phone}</p>
//         <p><strong>Outstanding Balance:</strong> ${outstandingBalance}</p>
//         <p><strong>Patient Responsibility:</strong> ${patientResponsibility}</p>
//         {renderInsurance()}
//         <div className="ris-billing-notes">
//           <h3>Notes for New Claim</h3>
//           <table>
//             <thead>
//               <tr>
//                 <th>Biller</th>
//                 {/* <th>Claim Number</th> */}
//                 <th>Date</th>
//                 <th>Note</th>
                
//               </tr>
//             </thead>
//             <tbody>
//               { newNotes?.length > 0 ? newNotes.map((note, index) => (
//                 <tr key={index}>
//                   <td>{note.biller}</td>
//                   {/* <td>{note.claimNumber}</td> */}
//                   <td>{dateOfBirth(note.date)}</td>
//                   <td>{note.note}</td>
                  
//                 </tr>
//               )) : null }
//             </tbody>
//           </table>
//           <h4>Add Note for New Claim</h4>

//           <div className="ris-billing-add-note">
//           <input
//               type="text"
//               placeholder="Biller"
//               value={noteForm.biller}
//               onChange={e => setNoteForm({ ...noteForm, biller: e.target.value })}
//             />
//             {/* <input
//               type="text"
//               placeholder="Claim Number"
//               value={noteForm.claimNumber}
//               onChange={e => setNoteForm({ ...noteForm, claimNumber: e.target.value })}
//             /> */}
//             <input
//               type="text"
//               placeholder="Note"
//               value={noteForm.note}
//               onChange={e => setNoteForm({ ...noteForm, note: e.target.value })}
//             />
            
//             <button onClick={() => {
//               setNewNotes([...newNotes, { ...noteForm, date: currentDate }]);
//               handleAddNote(noteForm);
//               setNoteForm({ note: '', biller: '' });
//             }}>Add Note</button>
//           </div>
//         </div>
//       </div>
//     );
// } else {
//    return( 
//     <div className='loading-claims'>
//       <h3>Loading claims or no previous claims available...</h3>
//       <GearsSpinner alt='Gears GIF' style={{ width: '200px', height: '200px' }}/>
//     </div>
    
//   )}
// };
// //Custom claims selector component to retrieve all of the claims from 
//   const ClaimsSelector = () => { // value, onChange
//     const { currentPatient } = useContext(GlobalStateContext);
//     const [claimSelected, setClaimSelected] = useState([]);
//     const { claimId, setClaimId } = useContext(BillingGlobalStateContext);
//     const BASE_URL = process.env.REACT_APP_API_URL;


//     useEffect(() => {
 
//      const fetchPatientClaims = async () => {
//           if (currentPatient) {
//             try {
//               const response = await fetch(`${BASE_URL}/billing/claimsSelector?ris_patients_id=` + currentPatient.ris_patients_id)
//               if (response.ok) {
//                 const data = await response.json();
//                 logger.log("Data from claims: " + JSON.stringify(data));
//                 setClaimSelected(data.claimsData);
//                 }
//             } catch (error) {
//                 logger.error("Error fetching claims", error);
//             }
//           } else {
//             // window.alert("No patient selected.");
//             }
//         };
//         fetchPatientClaims();

//         }, []);

//         const onChange = (value) => {
//           if (setClaimId) { // Ensure it's available
//               setClaimId(value);
//           } else {
//               logger.error("setClaimId is not defined!");
//           }
//       };


//     return (
//         <select onChange={(e) => onChange(e.target.value)}>
//             <option value="">Select a claim</option> 
//             {claimSelected.map(claim => (
//                 <option key={claim.claim_id} value={claim.claim_id} className='claim-selector' placeholder="Select a Claim">
//                     {claim.claim_id} 
//                 </option>
//             ))}
//         </select>
//     );
// };

// // Adjustments component with note-adding feature
// const Adjustments = () => {
//   const [previousClaims, setPreviousClaims] = useState([
//     {
//       patient_name: '',
//       subscriber_full_address: '',
//       subscriber_phone: '',
//       outstanding_balance: ''
//     }
//   ]);
//   const [previousAdjustment, setPreviousAdjustment] = useState([
//     {
//       id: '',
//       claim_id: '',
//       deposit_date: '',
//       received_date: '',
//       accounting_date: '',
//       account_number: '',
//       insurance_or_self: '',
//       check_number: '',
//       billed_claims_amount: '',
//       adjustment_amount: '',
//       allowed_amount: '',
//       total_claim: '',
//       met_deductible: '',
//       patient_responsibility: '',
//       write_off: '',
//       patient_copay: '',
//       approved_or_denied: '',
//       denial_reason: '',
//       ris_patients_id: ''

//     }
//   ]);
//   const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
//   const { claimId } = useContext(BillingGlobalStateContext);
//   const { patientId, claimNumber } = useParams();
//   const [isEditing, setIsEditing] = useState(false);
//   const [historyNotes, setHistoryNotes] = useState([]);
//   const [noteForm, setNoteForm] = useState({ remit_number: '', note: '', biller: '' });
//   const currentDate = new Date().toISOString().split('T')[0];
//   const BASE_URL = process.env.REACT_APP_API_URL;
  
//   useEffect(() => {
//     const fetchClaims = async () => {
//       if (currentPatient) {
//         try {
//           // logger.log(currentPatient)
//           const response = await fetch(`${BASE_URL}/billing/getClaims?id=${currentPatient.ris_patients_id}&claim_id=${claimId}`);
//           if (response.status === 200) {
//             const data = await response.json();
//             logger.log("fetchClaims data: " + JSON.stringify(data))
//             // logger.log('Demographics Data: ', data.demographics);
//             // logger.log('Insured Data: ', data.insured);

//             // Update state with BOTH pieces of data
//             setPreviousClaims(data);
//           }
//         } catch (error) {
//           logger.error("Error fetching claims", error);
//         }
//       } else {
//         window.alert("No patient selected.");
//       }
//     };

//     const fetchAdjustments = async () => { //ws
      
//       if (currentPatient) {
//         try {
//           const response = await fetch(`${BASE_URL}/billing/adjustmentClaimDetails?ris_patients_id=` + currentPatient.ris_patients_id + 
//             "&claim_id=" + claimId
//           );
//           if (response.status === 200) {
//             const data = await response.json();
//             logger.log('Adjustment claim details: ', JSON.stringify(data));

//             // Update state with BOTH pieces of data
//             setPreviousAdjustment(data.cp_data);
//             setHistoryNotes(data.hn_data);
//             logger.log(historyNotes);
//           }
//         } catch (error) {
//           logger.error("Error fetching claims", error);
//         }
//       } else {
//         window.alert("No patient selected.");
//       }
//     }

//     fetchClaims();
//     fetchAdjustments();
//   }, [currentPatient, claimId]); // Re-run when `currentPatient` changes

//   const startEditing = () => {
//     setIsEditing(true);
//   };
// // Handlers for updating state
//   const handleDemographicsChange = (field, value) => {
//     setPreviousClaims(prev => ({
//       ...prev,
//       demographics: prev.demographics?.map((demo, index) =>
//         index === 0 ? { ...demo, [field]: value } : demo
//       ) || prev.demographics,
//     }));
//   };

//   const handleAdjustmentChange = (field, value) => {
//     setPreviousAdjustment(prev => {
//       const updated = prev.map((adj, index) =>
//         index === 0 ? { ...adj, [field]: value } : adj
//       );
//       logger.log('Updated Adjustment:', updated);
//       return updated;
//     });
//   };

//   // Save changes to database
//   const saveChanges = async () => {
//     try {
//       const updateClaim = async () => {
//         try {
//           const response = await fetch(`${BASE_URL}/billing/updateClaim?ris_patients_id=${currentPatient.ris_patients_id}`, {
//             method: 'PUT',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({demographics: previousClaims.demographics, claimId}),
//           });
//             if (response.ok) {  
//               const updatedData = await response.json();
//               logger.log("Updated claim: " + previousClaims)
//               logger.log('Claim updated successfully:', updatedData);
//               setPreviousClaims( prev => ({...prev, ...updatedData})); // Apply updates to states
//               // setTempDemographics(prev => ({ ...prev, ...updatedFields }));
//               // setIsDirty(false);
//           } else {
//               logger.log(JSON.stringify(previousClaims[0]))
//               logger.error('Failed to update claim:', await response.json());
//           }
//         } catch (error) {
//           logger.error('Error updating claim demographics:', error);
//         }
//       }

//   const updateAdjustment = async () => {
//     try {
//      const response = await fetch(`${BASE_URL}/billing/UpdateAdjustment`, {  //checking this out in backend
//             method: 'PUT',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(previousAdjustment[0]),
//         });

//         if (response.ok) {  
//             const updatedData = await response.json();
//             logger.log("Updated adjustment: " + previousAdjustment)
//             logger.log('Adjustment updated successfully:', updatedData);
//             setPreviousAdjustment( prev => ({...prev, ...updatedData})); // Apply updates to states
//             // setTempDemographics(prev => ({ ...prev, ...updatedFields }));
//             // setIsDirty(false);
//         } else {
//             logger.log(JSON.stringify(previousAdjustment[0]))
//             logger.error('Failed to update adjusment:', await response.json());
//         }
//     } catch (error) {
//         logger.error('Error updating claim details:', error);
//     }
//   }

//   updateAdjustment();
//   updateClaim();

//       window.alert("Changes saved successfully.");
//     } catch (error) {
//       logger.error("Error saving changes", error);
//       window.alert("Failed to save changes. Please try again.");
//     } finally {
//       setIsEditing(false); // Revert to view mode on success or failure
//     }
//   };
//   // Loading state
//   if (!previousClaims.demographics || previousClaims.demographics.length === 0) {
//     return( 
//     <div className='loading-claims'>
//       <h3>Loading claims or no previous claims available...</h3>
//       <GearsSpinner alt='Gears GIF' style={{ width: '200px', height: '200px' }}/>
//     </div>
    
//   )}
  
//   const demographics = previousClaims.demographics[0];
//   let adjustment = {};
//   if(previousAdjustment){
//     adjustment = previousAdjustment[0];
//   }


//  // && previousClaimsSummary?.length && setPreviousFinancialSummary?.length
//   const handleAddHistoryNote =  async (noteForm) => {
//     // if (previousClaims?.demographics?.length) { 
//     logger.log(JSON.stringify(noteForm))
//       try {
//         const response = await fetch(`${BASE_URL}/billing/historyNotes?claim_id=${claimId}`, {
//           method: 'POST',
//           headers: {
//               'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(noteForm),
//         });
//         if (response.status === 200) {
//           const data = await response.json();
//           logger.log("Added patient notes successfully: ")
//           setHistoryNotes(data);
//           // setPreviousAdjustment( prev => ({...prev, ...updatedData}));
//         }
//       } catch (error) {
//         logger.error("Error adding patient notes", error);
//         }
//     // }
//   }

//   return (
//     <div className="ris-billing-adjustments">
//       <BillingNavigation />
//       <div className='claim-history-header'>
//         <h2>Claim History for {demographics.patient_name || 'N/A'}</h2>
//         <button className="ris-little-blue-button" onClick={isEditing ? saveChanges : startEditing}>
//           {isEditing ? 'Save' : 'Edit'}
//         </button>
//         <ClaimsSelector />
//       </div>
//       {isEditing ? (
//         <>
//           <div className="ris-demographics">
//             <p>
//               <strong>Patient Name:</strong>{' '}
//               <input
//                 type="text"
//                 name="patient_name"
//                 value={demographics.patient_name || ''}
//                 onChange={(e) => handleDemographicsChange('patient_name', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Subscriber Full Address:</strong>{' '}
//               <input
//                 type="text"
//                 name="patient_address"
//                 value={demographics.patient_address || ''}
//                 onChange={(e) => handleDemographicsChange('patient_address', e.target.value)}
//                 className="ris-edit-input"
//               />
//               ,{' '}
//               <input
//                 type="text"
//                 name="patient_city"
//                 value={demographics.patient_city || ''}
//                 onChange={(e) => handleDemographicsChange('patient_city', e.target.value)}
//                 className="ris-edit-input"
//               />
//               ,{' '}
//               <input
//                 type="text"
//                 name="patient_state"
//                 value={demographics.patient_state || ''}
//                 onChange={(e) => handleDemographicsChange('patient_state', e.target.value)}
//                 className="ris-edit-input"
//               />
//               {' '}
//               <input
//                 type="text"
//                 name="patient_zip"
//                 value={demographics.patient_zip || ''}
//                 onChange={(e) => handleDemographicsChange('patient_zip', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Subscriber Phone Number:</strong>{' '}
//               <input
//                 type="text"
//                 name="patient_phone"
//                 value={demographics.patient_phone || ''}
//                 onChange={(e) => handleDemographicsChange('patient_phone', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             {/* <p>
//               <strong>Outstanding Balance for Claim:</strong>{' '} 
//               <input
//                 type="text"
//                 name="outstanding_balance"
//                 value={demographics.outstanding_balance || ''}
//                 onChange={(e) => handleDemographicsChange('outstanding_balance', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p> */}
//             {/* <p>
//               <strong>Patient Responsibility for Claim:</strong>{' '} 
//               <input
//                 type="text"
//                 name="patient_responsibility"
//                 value={demographics.patient_responsibility || ''}
//                 onChange={(e) => handleDemographicsChange('patient_responsibility', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p> */}
//           </div>

//           <h3>Claim Details</h3>
//           <div className="ris-billing-claim-details">
//             <p>
//               <strong>Claim Number:</strong>{' '}
//               <input
//                 type="text"
//                 name="claim_id"
//                 value={adjustment.claim_id || ''}
//                 onChange={(e) => handleAdjustmentChange('claim_id', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Date Received:</strong>{' '}
//               <input
//                 type="date"
//                 name="received_date"
//                 value={adjustment.received_date || ''}
//                 onChange={(e) => handleAdjustmentChange('received_date', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Deposit Date:</strong>{' '}
//               <input
//                 type="date"
//                 name="deposit_date"
//                 value={adjustment.deposit_date || ''}
//                 onChange={(e) => handleAdjustmentChange('deposit_date', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Accounting Date:</strong>{' '}
//               <input
//                 type="date"
//                 name="accounting_date"
//                 value={adjustment.accounting_date || ''}
//                 onChange={(e) => handleAdjustmentChange('accounting_date', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Account Number:</strong>{' '}
//               <input
//                 type="text"
//                 name="account_number"
//                 value={adjustment.account_number || ''}
//                 onChange={(e) => handleAdjustmentChange('account_number', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Insurance or Self Pay:</strong>{' '}
//               <input
//                 type="text"
//                 name="insurance_or_self"
//                 value={adjustment.insurance_or_self || ''}
//                 onChange={(e) => handleAdjustmentChange('insurance_or_self', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Check Number:</strong>{' '}
//               <input
//                 type="text"
//                 name="check_number"
//                 value={adjustment.check_number || ''}
//                 onChange={(e) => handleAdjustmentChange('check_number', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Billed Claims Amount:</strong>{' '}
//               <input
//                 type="number"
//                 name="billed_claims_amount"
//                 value={adjustment.billed_claims_amount || ''}
//                 onChange={(e) => handleAdjustmentChange('billed_claims_amount', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Allowed Amount:</strong>{' '}
//               <input
//                 type="number"
//                 name="allowed_amount"
//                 value={adjustment.allowed_amount || ''}
//                 onChange={(e) => handleAdjustmentChange('allowed_amount', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Adjustment Amount:</strong>{' '}
//               <input
//                 type="number"
//                 name="adjustment_amount"
//                 value={adjustment.adjustment_amount || ''}
//                 onChange={(e) => handleAdjustmentChange('adjustment_amount', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Total Claim:</strong>{' '}
//               <input
//                 type="number"
//                 name="total_claim"
//                 value={adjustment.total_claim || ''}
//                 onChange={(e) => handleAdjustmentChange('total_claim', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Met Deductible:</strong>{' '}
//               <input
//                 type="text"
//                 name="met_deductible"
//                 value={adjustment.met_deductible || ''}
//                 onChange={(e) => handleAdjustmentChange('met_deductible', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Patient Responsibility:</strong>{' '}
//               <input
//                 type="number"
//                 name="patient_responsibility"
//                 value={adjustment.patient_responsibility || ''}
//                 onChange={(e) => handleAdjustmentChange('patient_responsibility', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Write Off:</strong>{' '}
//               <input
//                 type="number"
//                 name="write_off"
//                 value={adjustment.write_off || ''}
//                 onChange={(e) => handleAdjustmentChange('write_off', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Patient Copay:</strong>{' '}
//               <input
//                 type="number"
//                 name="patient_copay"
//                 value={adjustment.patient_copay || ''}
//                 onChange={(e) => handleAdjustmentChange('patient_copay', e.target.value)}
//                 className="ris-edit-input"
//               />
//             </p>
//             <p>
//               <strong>Approved or Denied:</strong>{' '}
//               <select
//                   value={adjustment.approved_or_denied || '0'}
//                   onChange={(e) => handleAdjustmentChange('approved_or_denied', e.target.value)}
//                   className="patient-type-select"
//                 >
//                   <option value={0}>Approved</option>
//                   <option value={1}>Denied</option>
//                 </select>
//               <p><strong>Reason:</strong></p>
//               <input
//                 type="text"
//                 name="denial_reason"
//                 value={adjustment.denial_reason || ''}
//                 onChange={(e) => handleAdjustmentChange('denial_reason', e.target.value)}
//                 className="ris-edit-input"
//               />

//             </p>
//           </div>

//           <div className="ris-billing-adjustments-notes">
//             <h3>Notes for Claim {claimNumber}</h3>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Biller</th>
//                   <th>Remit Number</th>
//                   <th>Date</th>
//                   <th>Note</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {historyNotes?.length > 0 ? historyNotes.map((note, index) => (
//                   <tr key={index}>
//                     <td>{note.biller || 'N/A'}</td>
//                     <td>{note.remit_number || 'N/A'}</td>
//                     <td>{dateOfBirth(note.date) || 'N/A'}</td>
//                     <td>{note.note || 'N/A'}</td>
//                   </tr>
//                 )) : null }
//               </tbody>
//             </table>
//             <div className="ris-billing-add-note">
//               <h4>Add Note for Claim {claimNumber}</h4>
//               <input
//                 type="text"
//                 placeholder="Biller"
//                 value={noteForm.biller}
//                 onChange={(e) => setNoteForm({ ...noteForm, biller: e.target.value })}
//               />
//               <input
//                 type="text"
//                 placeholder="Remit Number"
//                 value={noteForm.remit_number}
//                 onChange={(e) => setNoteForm({ ...noteForm, remit_number: e.target.value })}
//               />
//               <input
//                 type="text"
//                 placeholder="Note"
//                 value={noteForm.note}
//                 onChange={(e) => setNoteForm({ ...noteForm, note: e.target.value })}
//               />
//               <button
//                 onClick={() => {
//                   logger.log("Button clicked!");
//                   setHistoryNotes([...historyNotes, { ...noteForm, date: currentDate }]);
//                   handleAddHistoryNote(noteForm);
//                   saveChanges();
//                   setNoteForm({ remit_number: '', note: '', biller: '' });
//                 }}
//               >
//                 Add Note
//               </button>
//             </div>
//           </div>
//         </>
//       ) : (
//         <div className="ris-demographics">
//           <p><strong>Patient Name:</strong> {demographics.patient_name || 'N/A'}</p>
//           <p>
//             <strong>Subscriber Full Address:</strong>{' '}
//             {demographics.patient_address || 'N/A'}, {demographics.patient_city || 'N/A'},{' '}
//             {demographics.patient_state || 'N/A'} {demographics.patient_zip || 'N/A'}
//           </p>
//           <p><strong>Subscriber Phone Number:</strong> {demographics.patient_phone || 'N/A'}</p>
//           {/* <p><strong>Outstanding Balance:</strong> ${(demographics.outstanding_balance || 0).toFixed(2)}</p> */}
//           {/* <p><strong>Patient Responsibility For Claim:</strong> Not Known ATM</p> */}

//           <h3>Claim Details</h3>
//           <div className="ris-billing-claim-details">
//             <p><strong>Claim Number:</strong> {adjustment.claim_id || 'N/A'}</p>
//             <p><strong>Date Received:</strong> {(adjustment.received_date) || 'N/A'}</p>
//             <p><strong>Deposit Date:</strong> {(adjustment.deposit_date) || 'N/A'}</p>
//             <p><strong>Accounting Date:</strong> {(adjustment.accounting_date) || 'N/A'}</p>
//             <p><strong>Account Number:</strong> {adjustment.account_number || 'N/A'}</p>
//             <p><strong>Insurance or Self Pay:</strong> {adjustment.insurance_or_self || 'N/A'}</p>
//             <p><strong>Check Number:</strong> {adjustment.check_number || 'N/A'}</p>
//             <p><strong>Billed Claims Amount:</strong> ${adjustment.billed_claims_amount || 'N/A'}</p>
//             <p><strong>Allowed Amount:</strong> ${adjustment.allowed_amount || 'N/A'}</p>
//             <p><strong>Adjustment Amount:</strong> ${adjustment.adjustment_amount || 'N/A'}</p>
//             <p><strong>Total Claim:</strong> ${adjustment.total_claim || 'N/A'}</p>
//             <p><strong>Met Deductible:</strong> {adjustment.met_deductible || 'N/A'}</p>
//             <p><strong>Patient Responsibility:</strong> ${adjustment.patient_responsibility || 'N/A'}</p>
//             <p><strong>Write Off:</strong> ${adjustment.write_off || 'N/A'}</p>
//             <p><strong>Patient Copay:</strong> ${adjustment.patient_copay || 'N/A'}</p>
//             <p><strong>Approved or Denied:</strong> {adjustment.approved_or_denied || 'N/A'}</p>
//           </div>

//           <div className="ris-billing-adjustments-notes">
//             <h3>Notes for Claim {claimId}</h3>
//             <table>
//               <thead>
//                 <tr>
//                   <th>Biller</th>
//                   <th>Remit Number</th>
//                   <th>Date</th>
//                   <th>Note</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {historyNotes ? historyNotes.map((note, index) => (
//                   <tr key={index}>
//                     <td>{note.biller || 'N/A'}</td>
//                     <td>{note.remit_number || 'N/A'}</td>
//                     <td>{dateOfBirth(note.date) || 'N/A'}</td>
//                     <td>{note.note || 'N/A'}</td>
//                   </tr>
//                 )) : null}
//               </tbody>
//             </table>
//             <div className="ris-billing-add-note">
//               <h4>Add Note for Claim {claimId}</h4>
//               <input
//                 type="text"
//                 placeholder="Biller"
//                 value={noteForm.biller}
//                 onChange={(e) => setNoteForm({ ...noteForm, biller: e.target.value })}
//               />
//               <input
//                 type="text"
//                 placeholder="Remit Number"
//                 value={noteForm.remit_number}
//                 onChange={(e) => setNoteForm({ ...noteForm, remit_number: e.target.value })}
//               />
//               <input
//                 type="text"
//                 placeholder="Note"
//                 value={noteForm.note}
//                 onChange={(e) => setNoteForm({ ...noteForm, note: e.target.value })}
//               />
//               <button
//                 onClick={() => {
//                   setHistoryNotes([...historyNotes, { ...noteForm, date: currentDate }]);
//                   handleAddHistoryNote(noteForm);
//                   setNoteForm({ remit_number: '', note: '', biller: '' });
//                 }}
//               >
//                 Add Note
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
// // PatientSummary component with updated summary table and note-adding feature
// const PatientSummary = () => {
//   const [previousClaims, setPreviousClaims] = useState([]);
//   const [previousClaimsSummary, setPreviousClaimsSummary] = useState([]);
//   const [previousFinancialSummary, setPreviousFinancialSummary] = useState([]);
//   const [totalAdjustments, setTotalAdjustments] = useState(0.00);
//   const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);
//   const { outstandingBalance, setOutstandingBalance } = useContext(BillingGlobalStateContext);
//   const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);  
//   const { claimId, setclaimId } = useContext(BillingGlobalStateContext);
//   const { patientId } = useParams();
//   // const patient = patients.find(p => p.patientId === parseInt(patientId));
//   const [patientNotes, setPatientNotes] = useState([]);
//   const [noteForm, setNoteForm] = useState({ note: '', biller: '' });
//   const currentDate = new Date().toISOString().split('T')[0];
//   const BASE_URL = process.env.REACT_APP_API_URL;


//   // if (!patient) return <div>Patient not found</div>;

//   // const patientClaims = claims.filter(c => c.patientId === patient.patientId);
//   // const subscriber = patient.primaryInsurance?.subscriber || {};

//     useEffect(() => {
//     const fetchClaims = async () => {
//       if (currentPatient) {
//         try {
//           // logger.log(currentPatient)
//             const response = await fetch(`${BASE_URL}/billing/getClaims?id=${currentPatient.ris_patients_id}&claim_id=${claimId}`);          
//             if (response.status === 200) {
//             const data = await response.json();
//             // logger.log('Demographics Data: ', data.demographics);
//             // logger.log('Insured Data: ', data.insured);

//             // Update state with BOTH pieces of data
//             setPreviousClaims(data);
//           }
//         } catch (error) {
//           logger.error("Error fetching claims", error);
//         }
//       } else {
//         window.alert("No patient selected.");
//       }
//     };

//     const fetchSummaries = async () => {
//       if (currentPatient) {
//         try {
//           const response = await fetch(`${BASE_URL}/billing/patientSummaries?ris_patients_id=${currentPatient.ris_patients_id}`);
//           if (response.status === 200) {
//             const data = await response.json();
//             // logger.log('Patient summaries' + JSON.stringify(data))
//             // logger.log('Claims Summary ' + data.ps_data[0])
//             //logger.log('Financial Summary ' + JSON.stringify(data.fs_data[0]))

//             // Update state with BOTH pieces of data
//             setPreviousClaimsSummary(data.ps_data);
//             setPreviousFinancialSummary(data.fs_data[0]);
//             setTotalAdjustments(data.ta_data[0].total_adjustments)
//             setPatientNotes(data.pn_data);
//             // logger.log(JSON.stringify(patientNotes))
//           }
//         } catch (error) {
//           logger.error("Error fetching claims", error);
//         }
//       } else {
//         window.alert("No patient selected.");
//       }
//     };

//     fetchClaims();
//     fetchSummaries();
//   }, []); // Re-run when `currentPatient` changes

  
//   //does previous claims exist
//   if (previousClaims?.demographics?.length && previousClaimsSummary?.length) { // && previousClaimsSummary?.length && setPreviousFinancialSummary?.length

//   const handleAddNote = async (noteForm) => {
//     try {
//           const response = await fetch(`${BASE_URL}/billing/patientNotes?ris_patients_id=${currentPatient.ris_patients_id}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify(noteForm),
//           });
//           if (response.status === 200) {
//             const data = await response.json();
//             logger.log("Added patient notes successfully: ")
//             setPatientNotes(data);
//             // setPreviousAdjustment( prev => ({...prev, ...updatedData}));
//           }
//         } catch (error) {
//           logger.error("Error adding patient notes", error);
//         }
//   }
//   // logger.log("Previous claims summary: ", previousClaimsSummary[0].met_deductible)
  
//     return (
//       <div className="ris-billing-patient-summary">
//         <BillingNavigation />
//         <h2>Patient Summary for {previousClaims.demographics[0].patient_name}</h2>
//         <p><strong>Patient Name:</strong> {previousClaims.demographics[0].patient_name}</p>
//         <p><strong>Subscriber Full Address:</strong> {previousClaims.demographics[0].patient_address}, {previousClaims.demographics[0].patient_city}, {previousClaims.demographics[0].patient_state} {previousClaims.demographics[0].patient_zip}</p>
//         <p><strong>Subscriber Phone Number:</strong> {previousClaims.demographics[0].patient_phone}</p>
//         <p><strong>Outstanding Balance:</strong> ${outstandingBalance}</p>
//         <p><strong>Patient Responsibility:</strong> ${patientResponsibility} </p>
//         {/* <p><strong>Subscriber Name:</strong> {subscriber.firstName} {subscriber.lastName}</p> */}
//         <h3>Summary of Claims</h3>
//         <table className="ris-billing-claims-table">
//           <thead>
//             <tr>
//               <th>Claim Number</th>
//               <th>Claim Date</th>
//               <th>Copay Amount</th>
//               <th>Patient Responsibility</th>
//               <th>Total Claim</th>
//               <th>Open or Final</th>
//             </tr>
//           </thead>
//            <tbody>
//             {previousClaimsSummary.map(claim => (
//               <tr key={claim.claim_id}>
//                 <td>{claim.claim_id}</td>
//                 <td>{dateOfBirth(claim.created_at)}</td>
//                 <td>${claim.patient_copay}</td>
//                 <td>${claim.patient_responsibility}</td>
//                 <td>${claim.total_claim}</td>
//                 <td>{claim.open_or_final ? "Open" : "Final"}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         <h3>Financial Summary</h3>
//         <table className="ris-billing-summary-table">
//           <thead>
//             <tr>
//               <th>Deductible Met</th>
//               <th>Outstanding Patient Bal.</th>
//               <th>Patient Paid this Year</th>
//               <th>Insurance Paid this Year</th>
//               <th>Total Adjustments</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>{previousClaimsSummary[0]?.met_deductible == 1 ? 'Yes' : 'No'}</td>
//               <td>${outstandingBalance}</td>
//               <td>${previousFinancialSummary.patient_paid_this_year}</td>
//               <td>${previousFinancialSummary.insurance_paid_this_year}</td>
//               <td>${totalAdjustments}</td>
//             </tr>
//           </tbody>
//         </table>
//         <div className="ris-billing-patient-notes">
//           <h3>Patient Notes</h3>
//           <table>
//             <thead>
//               <tr>
//                   <th>Biller</th>
//                   <th>Date</th>
//                   <th>Note</th>
                
//               </tr>
//             </thead>
//             <tbody>
              
//               {patientNotes.map((note, index) => (
//                 <tr key={index}>
//                   <td>{note.biller || "N/A"}</td>
//                   <td>{dateOfBirth(note.date)}</td>
//                   <td>{note.note}</td>
                  
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <div className="ris-billing-add-note">
//             <h4>Add Note</h4>
//             <input
//               type="text"
//               placeholder="Biller"
//               value={noteForm.biller}
//               onChange={e => setNoteForm({ ...noteForm, biller: e.target.value })}
//             />
//             <input
//               type="text"
//               placeholder="Note"
//               value={noteForm.note}
//               onChange={e => setNoteForm({ ...noteForm, note: e.target.value })}
//             />
            
//             <button onClick={() => {
//               setPatientNotes([...patientNotes, { ...noteForm, date: currentDate }]);
//               handleAddNote(noteForm);
//               setNoteForm({ note: '', biller: '' });
              
//             }}>Add Note</button>
//           </div>
//         </div>
//       </div>
//     );
//     } else {
//     return( 
//     <div className='loading-claims'>
//       <h3>Loading claims or no previous claims available...</h3>
//       <GearsSpinner alt='Gears GIF' style={{ width: '200px', height: '200px' }}/>
//     </div>
    
//   )}
// };

// // ClaimsSummary component with sorting functionality and filtering by days
// const ClaimsSummary = () => {
//   const [sortedClaims, setSortedClaims] = useState([
//     {
//       id: '',
//       created_at: '',
//       patient_name: '',
//       patient_responsibility: '',
//       total_claim: '',
//       remit_number: ''
//     }
//   ]);
//   const [sortedClaimsCopy, setSortedClaimsCopy] = useState([
//     {
//       id: '',
//       created_at: '',
//       patient_name: '',
//       patient_responsibility: '',
//       total_claim: '',
//       remit_number: ''
//     }
//   ]);
//   const [filterDays, setFilterDays] = useState("all");
//   const BASE_URL = process.env.REACT_APP_API_URL;

//   // const { outstandingBalance, setOutstandingBalance } = useContext(BillingGlobalStateContext);
//   // const { patientResponsibility, setPatientResponsibility } = useContext(BillingGlobalStateContext);  

//   useEffect(() => {

//     const claimsSummaryData = async () => {
//       try{
//         const response = await fetch(`${BASE_URL}/billing/claimsSummary`)
//           if (response.status === 200){
//             const data = await response.json()
//             logger.log(JSON.stringify(data))
//             setSortedClaims(data)
//             setSortedClaimsCopy(data)
//           }
//         }
//         catch (error){
//           logger.error(`Could not fetch claims`)
//         }
//     }

//     claimsSummaryData();
//   }, []);

//   useEffect(() => {
//   filterDates();
// }, [filterDays]);

//   const filterDates = () => {
//       const now = Date.now();

//       setSortedClaimsCopy(sortedClaims);

//       const filtered = sortedClaims.filter(claim => {
//         const claimDate = new Date(claim.created_at).getTime();

//         if (filterDays === "olderThan120") {
//           return now - claimDate > 120 * 24 * 60 * 60 * 1000;
//         }

//         if (filterDays === "all") {
//           return claim.created_at;
//         }

//         if (!filterDays) return true;

//         return now - claimDate <= filterDays * 24 * 60 * 60 * 1000;
//       });

//       // Ensure you're sorting by the correct, existing field
//       const sorted = [...filtered].sort((a, b) => 
//         new Date(a.created_at) - new Date(b.created_at)
//       );
//       // logger.log(sorted)

//       setSortedClaimsCopy(sorted);
//     }

//   return (
//     <div className="ris-billing-claims-summary">
//       <BillingNavigation />
//       <h2>Claims Summary</h2>
//       <div>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(30)}>Last 30 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(60)}>Last 60 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(90)}>Last 90 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(120)}>Last 120 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays("olderThan120")}>Older than 120 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays("all")}>All</button>
//       </div>
//       <table>
//         <thead>
//           <tr>
//             <th>Claim Number</th>
//             <th>Claim Date</th>
//             <th>Patient Name</th>
//             <th>Patient Responsibility</th>
//             <th>Total Claim</th>
//             <th>Remit Numbers</th>
//           </tr>
//         </thead>
//         <tbody>
//           {(() => {
//             // Group claims by claim_id
//             const claimMap = new Map();
//             sortedClaimsCopy.forEach((claim) => {
//               if (!claimMap.has(claim.claim_id)) {
//                 claimMap.set(claim.claim_id, []);
//               }
//               claimMap.get(claim.claim_id).push(claim);
//             });

//             // Render one row per unique claim_id
//             return Array.from(claimMap.entries()).map(([claim_id, groupedClaims]) => {
//               const baseClaim = groupedClaims[0]; // Use the first for consistent info
//               const remitNumbers = groupedClaims
//                 .map(claim => claim.remit_number) // Extract remit_number from groupedClaims
//                 .filter(Boolean); // Removes null/undefined if needed

//               return (
//                 <tr key={claim_id || `${baseClaim.patient_name}-${baseClaim.created_at}`}>
//                   <td>{claim_id}</td>
//                   <td>{dateOfBirth(baseClaim.created_at)}</td>
//                   <td>{baseClaim.patient_name}</td>
//                   <td>${baseClaim.patient_responsibility}</td>
//                   <td>${baseClaim.total_claim}</td>
//                   <td>{remitNumbers.length > 0 ? remitNumbers.join(', ') : 'N/A'}</td>
//                 </tr>
//               );
//             });
//           })()}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// // DenialsSummary component with filtering functionality
// const DenialsSummary = () => {
//   const [sortedClaims, setSortedClaims] = useState([
//     {
//       id: '',
//       insured_name: '',
//       patient_name: '',
//       exam: '',
//       cpt_code: '',
//       denial_reason: '',
//       biller: '',
//       created_at: ''
//     }
//   ]);
//   const [sortedClaimsCopy, setSortedClaimsCopy] = useState([
//     {
//       id: '',
//       insured_name: '',
//       patient_name: '',
//       exam: '',
//       cpt_code: '',
//       denial_reason: '',
//       biller: '',
//       created_at: ''
//     }
//   ]);
//   const [filterDays, setFilterDays] = useState("all");
//   const BASE_URL = process.env.REACT_APP_API_URL;


//   useEffect(() => {
//     const denialsSummaryData = async () => {
//       try{
//         const response = await fetch(`${BASE_URL}/billing/denialsSummary`)
//           if (response.status === 200){
//             const data = await response.json()
//             logger.log(JSON.stringify(data))
//             setSortedClaims(data)
//             setSortedClaimsCopy(data)
//           }
//         }
//         catch (error){
//           logger.error(`Could not fetch claims`)
//         }
//     }
//     denialsSummaryData();

//   }, []);

//   useEffect(() => {
//   filterDates();
// }, [filterDays]);

//   const filterDates = () => {
//       const now = Date.now();

//       setSortedClaimsCopy(sortedClaims);

//       const filtered = sortedClaims.filter(claim => {
//         const claimDate = new Date(claim.created_at).getTime();

//         if (filterDays === "olderThan120") {
//           return now - claimDate > 120 * 24 * 60 * 60 * 1000;
//         }

//         if (filterDays === "all") {
//           return claim.created_at;
//         }

//         if (!filterDays) return true;

//         return now - claimDate <= filterDays * 24 * 60 * 60 * 1000;
//       });

//       // Ensure you're sorting by the correct, existing field
//       const sorted = [...filtered].sort((a, b) => 
//         new Date(a.created_at) - new Date(b.created_at)
//       );
//       // logger.log(sorted)

//       setSortedClaimsCopy(sorted);
//     }

//   return (
//     <div className="ris-billing-denials-summary">
//       <BillingNavigation />
//       <h2>Denials Summary</h2>
//       <div>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(30)}>Last 30 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(60)}>Last 60 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(90)}>Last 90 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays(120)}>Last 120 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays("olderThan120")}>Older than 120 Days</button>
//         <button className='ris-billing-summary-sort' onClick={() => setFilterDays("all")}>All</button>
//       </div>
//       <table>
//         <thead>
//           <tr>
//             <th>Claim Number</th>
//             <th>Claim Date</th>
//             <th>Patient Name</th>
//             <th>Payor</th>
//             <th>Exam Description</th>
//             <th>CPT</th>
//             <th>Reason</th>
//             <th>Biller</th>
//           </tr>
//         </thead>
//         <tbody>
//           {(() => {
//   // Group denials by claim_id
//   const denialMap = new Map();
//   sortedClaimsCopy.forEach(claim => {
//     if (!denialMap.has(claim.claim_id)) {
//       denialMap.set(claim.claim_id, []);
//     }
//     denialMap.get(claim.claim_id).push(claim);
//   });

//   // Render one row per unique claim_id
//   return Array.from(denialMap.entries()).map(([claim_id, groupedClaims], index) => {
//     const baseClaim = groupedClaims[0]; // Use the first claim for display consistency

//     // Collect all CPT codes, filter out falsy values, and remove duplicates
//     const cptCodes = Array.from(new Set(
//       groupedClaims.map(c => c.cpt_code).filter(Boolean)
//     ));

//     return (
//       <tr key={claim_id || index}>
//         <td>{claim_id || "N/A"}</td>
//         <td>{dateOfBirth(baseClaim.created_at) || "N/A"}</td>
//         <td>{baseClaim.patient_name || "N/A"}</td>
//         <td>{baseClaim.insured_name || "N/A"}</td>
//         <td>{baseClaim.exam || "N/A"}</td>
//         <td>{cptCodes.length > 0 ? cptCodes.join(', ') : "N/A"}</td>
//         <td>{baseClaim.denial_reason || "N/A"}</td>
//         <td>{baseClaim.biller || "N/A"}</td>
//       </tr>
//     );
//   });
// })()}

//         </tbody>
//       </table>
//     </div>
//   );
// };
// //
// // Main component
// const Billing = () => {
//     const [searchQuery, setSearchQuery] = useState('');
//     const [patients, setPatients] = useState([]);
//     const navigate = useNavigate();
//     const { currentPatient, setCurrentPatient } = useContext(GlobalStateContext);

//     const handleSearch = async (query) => {
//         setSearchQuery(query);
//         logger.log('query', query)
//         // Debounce search to avoid too many API calls
//         //need to add search button to make less API calls
//         const results = await api.searchPatientsApi(query);
//         logger.log('results:', results)
//         setPatients(results);
//       };

//   return (
//     <div className="ris-billing-container">
//       <Routes>
//         <Route path="/generate/:patientId" element={<Claims />} />
//         <Route path="/adjustments" element={<Adjustments />} />
//         <Route path="/patient-summary" element={<PatientSummary />} />
//         <Route path="/claims-summary" element={<ClaimsSummary />} />
//         <Route path="/denials-summary" element={<DenialsSummary />} />
//         <Route path="/" element={<div><BillingNavigation />
//         <div>Select patient from search:</div>
//         <div className="search-patient">
//           <input
//             type="text"
//             placeholder="Search Patient"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)} // This does work so far
//             className="search-input"
//           />
//           <button className='search-button' onClick={() => handleSearch(searchQuery)}>Search</button>
//           </div>
//               <ul className="patient-list">
//               {patients.map((patient) => (
//                 <li
//                   key={patient.id}
//                   onClick={() => {setCurrentPatient(patient); navigate(`/billing/generate/${patient.id}`)}}
//                   className="patient-item"
//                 >
//                   {patient.first_name} {patient.last_name} | {patient.dob} | {patient.street_number} {patient.street_name}
//                 </li>
//               ))}
//             </ul>
          
//         </div>} />
//       </Routes>
//     </div>
//   );
// };

// export default Billing;